import { j as _typeof, _ as _slicedToArray, e as _objectSpread2, g as _toConsumableArray, h as _extends, n as _defineProperty } from './_rollupPluginBabelHelpers-f5c57928.js';
import 'moment/locale/de';
import 'moment/locale/it';
import 'moment/locale/fr';
import 'moment/locale/zh-cn';
import 'moment/locale/pt';
import 'moment/locale/es';
import 'moment/locale/th';
import 'moment/locale/sq';
import 'moment/locale/ar';
import 'moment/locale/be';
import 'moment/locale/bg';
import 'moment/locale/ca';
import 'moment/locale/hr';
import 'moment/locale/cs';
import 'moment/locale/da';
import 'moment/locale/nl';
import 'moment/locale/eo';
import 'moment/locale/et';
import 'moment/locale/fi';
import 'moment/locale/el';
import 'moment/locale/he';
import 'moment/locale/hi';
import 'moment/locale/hu';
import 'moment/locale/is';
import 'moment/locale/id';
import 'moment/locale/ga';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/lv';
import 'moment/locale/lt';
import 'moment/locale/mk';
import 'moment/locale/ms';
import 'moment/locale/mt';
import 'moment/locale/nb';
import 'moment/locale/pl';
import 'moment/locale/ro';
import 'moment/locale/ru';
import 'moment/locale/sr';
import 'moment/locale/sk';
import 'moment/locale/tr';
import 'moment/locale/uk';
import 'moment/locale/vi';
import 'moment/locale/en-gb';
import 'moment/locale/en-ca';
import 'react-dates/initialize';
import moment from 'moment';
import PropTypes from 'prop-types';
import React__default, { forwardRef as forwardRef$1, cloneElement, useState, useLayoutEffect, useEffect, useRef, useCallback, useMemo } from 'react';
import { DayPickerRangeController } from 'react-dates';
import { k as nodeOrStringOrFuncProp, s as src, n as nodeOrStringProp, l as dateRangeShape, q as dayPricesShape } from './PropTypes-9aad034b.js';
import { u as useWindowSize } from './useWindowSize-51f81a2a.js';
import { M as ModalHeader } from './ModalHeader-daaa2bf6.js';
import SearchBarItem from './SearchBarItem.js';
import { createPortal } from 'react-dom';
import { S as SUPPORTED_REGION_LOCALES } from './general-2a8d8650.js';
import LoadingBlock from './LoadingBlock.js';
import { B as Button } from './Button-9db40655.js';

/**
 * Creates a new object with the specified keys omitted.
 *
 * @param {object} obj - The object from which to omit keys.
 * @param {string[]} keysToOmit - An array of strings representing the keys to omit.
 * @returns {object} - A new object with the specified keys omitted.
 * @throws {TypeError} - If the first argument is not an object or the second argument is not an array of strings.
 */
function omitNew(obj, keysToOmit) {
  if (_typeof(obj) !== 'object' || obj === null) {
    throw new TypeError('First argument must be an object');
  }
  if (!Array.isArray(keysToOmit)) {
    throw new TypeError('Second argument must be an array of strings');
  }
  var filteredEntries = Object.entries(obj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return !keysToOmit.includes(key);
  });
  return Object.fromEntries(filteredEntries);
}

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement$1(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement$1(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement$1(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement$1(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement$1(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement$1(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement$1(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement$1(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement$1(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement$1(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement$1(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement$1(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement$1(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement$1(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement$1(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce$1(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$1(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
  return document.body;
};

function hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
  }

  return value;
}
function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function debounce(fn, ms) {
  // Avoid wrapping in `setTimeout` if ms is 0 anyway
  if (ms === 0) {
    return fn;
  }

  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn(arg);
    }, ms);
  };
}
function removeProperties(obj, keys) {
  var clone = Object.assign({}, obj);
  keys.forEach(function (key) {
    delete clone[key];
  });
  return clone;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) === index;
  });
}
function getBasePlacement(placement) {
  return placement.split('-')[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

function div() {
  return document.createElement('div');
}
function isElement(value) {
  return ['Element', 'Fragment'].some(function (type) {
    return isType(value, type);
  });
}
function isNodeList(value) {
  return isType(value, 'NodeList');
}
function isMouseEvent(value) {
  return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (isElement(value)) {
    return [value];
  }

  if (isNodeList(value)) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;

  var _normalizeToArray = normalizeToArray(elementOrElements),
      element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX,
      clientY = event.clientY;
  return popperTreeData.every(function (_ref) {
    var popperRect = _ref.popperRect,
        popperState = _ref.popperState,
        props = _ref.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;

    if (!offsetData) {
      return true;
    }

    var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
    var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
  // `webkitTransitionEnd`...

  ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
    box[method](event, listener);
  });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */

function actualContains(parent, child) {
  var target = child;

  while (target) {
    var _target$getRootNode;

    if (parent.contains(target)) {
      return true;
    }

    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }

  return false;
}

var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */

function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }

  currentInput.isTouch = true;

  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */

function onDocumentMouseMove() {
  var now = performance.now();

  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);
  }

  lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */

function onWindowBlur() {
  var activeElement = document.activeElement;

  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;

    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener('blur', onWindowBlur);
}

var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser$1 ? // @ts-ignore
!!window.msCrypto : false;

function createMemoryLeakWarning(method) {
  var txt = method === 'destroy' ? 'n already-' : ' ';
  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
}
function clean(value) {
  var spacesAndTabs = /[ \t]{2,}/g;
  var lineStartWithSpaces = /^[ \t]*/gm;
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}

function getDevMessage(message) {
  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}

function getFormattedMessage(message) {
  return [getDevMessage(message), // title
  'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
  'line-height: 1.5', // footer
  'color: #a6a095;'];
} // Assume warnings and errors never have the same message

var visitedMessages;

if (process.env.NODE_ENV !== "production") {
  resetVisitedMessages();
}

function resetVisitedMessages() {
  visitedMessages = new Set();
}
function warnWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console;

    visitedMessages.add(message);

    (_console = console).warn.apply(_console, getFormattedMessage(message));
  }
}
function errorWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console2;

    visitedMessages.add(message);

    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
  }
}
function validateTargets(targets) {
  var didPassFalsyValue = !targets;
  var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
  errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
  errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
}

var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: 'fade',
  arrow: true,
  content: '',
  inertia: false,
  maxWidth: 350,
  role: 'tooltip',
  theme: '',
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: 'auto',
    expanded: 'auto'
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: '',
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {},
  onBeforeUpdate: function onBeforeUpdate() {},
  onCreate: function onCreate() {},
  onDestroy: function onDestroy() {},
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  onUntrigger: function onUntrigger() {},
  onClickOutside: function onClickOutside() {},
  placement: 'top',
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: 'mouseenter focus',
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
  /* istanbul ignore else */
  if (process.env.NODE_ENV !== "production") {
    validateProps(partialProps, []);
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps = plugins.reduce(function (acc, plugin) {
    var name = plugin.name,
        defaultValue = plugin.defaultValue;

    if (name) {
      var _name;

      acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
    }

    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
  return props;
}
function evaluateProps(reference, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
  out.aria = Object.assign({}, defaultProps.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
    content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
  };
  return out;
}
function validateProps(partialProps, plugins) {
  if (partialProps === void 0) {
    partialProps = {};
  }

  if (plugins === void 0) {
    plugins = [];
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (prop) {
    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
    var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

    if (didPassUnknownProp) {
      didPassUnknownProp = plugins.filter(function (plugin) {
        return plugin.name === prop;
      }).length === 0;
    }

    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
  });
}

var innerHTML = function innerHTML() {
  return 'innerHTML';
};

function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}

function createArrowElement(value) {
  var arrow = div();

  if (value === true) {
    arrow.className = ARROW_CLASS;
  } else {
    arrow.className = SVG_ARROW_CLASS;

    if (isElement(value)) {
      arrow.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow, value);
    }
  }

  return arrow;
}

function setContent(content, props) {
  if (isElement(props.content)) {
    dangerouslySetInnerHTML(content, '');
    content.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}
function getChildren(popper) {
  var box = popper.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box: box,
    content: boxChildren.find(function (node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function (node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function (node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function render(instance) {
  var popper = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute('data-state', 'hidden');
  box.setAttribute('tabindex', '-1');
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute('data-state', 'hidden');
  setContent(content, instance.props);
  popper.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);

  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper),
        box = _getChildren.box,
        content = _getChildren.content,
        arrow = _getChildren.arrow;

    if (nextProps.theme) {
      box.setAttribute('data-theme', nextProps.theme);
    } else {
      box.removeAttribute('data-theme');
    }

    if (typeof nextProps.animation === 'string') {
      box.setAttribute('data-animation', nextProps.animation);
    } else {
      box.removeAttribute('data-animation');
    }

    if (nextProps.inertia) {
      box.setAttribute('data-inertia', '');
    } else {
      box.removeAttribute('data-inertia');
    }

    box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

    if (nextProps.role) {
      box.setAttribute('role', nextProps.role);
    } else {
      box.removeAttribute('role');
    }

    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      setContent(content, instance.props);
    }

    if (nextProps.arrow) {
      if (!arrow) {
        box.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box.removeChild(arrow);
        box.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow) {
      box.removeChild(arrow);
    }
  }

  return {
    popper: popper,
    onUpdate: onUpdate
  };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away

render.$$tippy = true;

var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`

var mountedInstances = [];
function createTippy(reference, passedProps) {
  var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
  // 🔒 Private members
  // ===========================================================================

  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
  var currentTarget; // ===========================================================================
  // 🔑 Public members
  // ===========================================================================

  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: div(),
    popperInstance: popperInstance,
    props: props,
    state: state,
    plugins: plugins,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    setProps: setProps,
    setContent: setContent,
    show: show,
    hide: hide,
    hideWithInteractivity: hideWithInteractivity,
    enable: enable,
    disable: disable,
    unmount: unmount,
    destroy: destroy
  }; // TODO: Investigate why this early return causes a TDZ error in the tests —
  // it doesn't seem to happen in the browser

  /* istanbul ignore if */

  if (!props.render) {
    if (process.env.NODE_ENV !== "production") {
      errorWhen(true, 'render() function has not been supplied.');
    }

    return instance;
  } // ===========================================================================
  // Initial mutations
  // ===========================================================================


  var _props$render = props.render(instance),
      popper = _props$render.popper,
      onUpdate = _props$render.onUpdate;

  popper.setAttribute('data-tippy-root', '');
  popper.id = "tippy-" + instance.id;
  instance.popper = popper;
  reference._tippy = instance;
  popper._tippy = instance;
  var pluginsHooks = plugins.map(function (plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference.hasAttribute('aria-expanded');
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook('onCreate', [instance]);

  if (props.showOnCreate) {
    scheduleShow();
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding


  popper.addEventListener('mouseenter', function () {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper.addEventListener('mouseleave', function () {
    if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    }
  });
  return instance; // ===========================================================================
  // 🔒 Private methods
  // ===========================================================================

  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }

  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === 'hold';
  }

  function getIsDefaultRenderFn() {
    var _instance$props$rende;

    // @ts-ignore
    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }

  function getCurrentTarget() {
    return currentTarget || reference;
  }

  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }

  function getDefaultTemplateChildren() {
    return getChildren(popper);
  }

  function getDelay(isShow) {
    // For touch or keyboard input, force `0` delay for UX reasons
    // Also if the instance is mounted but not visible (transitioning out),
    // ignore delay
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
      return 0;
    }

    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }

  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }

    popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
    popper.style.zIndex = "" + instance.props.zIndex;
  }

  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }

    pluginsHooks.forEach(function (pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });

    if (shouldInvokePropsHook) {
      var _instance$props;

      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }

  function handleAriaContentAttribute() {
    var aria = instance.props.aria;

    if (!aria.content) {
      return;
    }

    var attr = "aria-" + aria.content;
    var id = popper.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      var currentValue = node.getAttribute(attr);

      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
      } else {
        var nextValue = currentValue && currentValue.replace(id, '').trim();

        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }

  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      if (instance.props.interactive) {
        node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
      } else {
        node.removeAttribute('aria-expanded');
      }
    });
  }

  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }

  function onDocumentPress(event) {
    // Moved finger to scroll instead of an intentional tap outside
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === 'mousedown') {
        return;
      }
    }

    var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

    if (instance.props.interactive && actualContains(popper, actualTarget)) {
      return;
    } // Clicked on the event listeners target


    if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
      return actualContains(el, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }

      if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
        return;
      }
    } else {
      invokeHook('onClickOutside', [instance, event]);
    }

    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
      // currentTarget. This lets a tippy with `focus` trigger know that it
      // should not show

      didHideDueToDocumentMouseDown = true;
      setTimeout(function () {
        didHideDueToDocumentMouseDown = false;
      }); // The listener gets added in `scheduleShow()`, but this may be hiding it
      // before it shows, and hide()'s early bail-out behavior can prevent it
      // from being cleaned up

      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }

  function onTouchMove() {
    didTouchMove = true;
  }

  function onTouchStart() {
    didTouchMove = false;
  }

  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener('mousedown', onDocumentPress, true);
    doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener('mousedown', onDocumentPress, true);
    doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback();
      }
    });
  }

  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }

  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;

    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise


    if (duration === 0) {
      return callback();
    }

    updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(box, 'add', listener);
    currentTransitionEndListener = listener;
  }

  function on(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node: node,
        eventType: eventType,
        handler: handler,
        options: options
      });
    });
  }

  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on('touchstart', onTrigger, {
        passive: true
      });
      on('touchend', onMouseLeave, {
        passive: true
      });
    }

    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      }

      on(eventType, onTrigger);

      switch (eventType) {
        case 'mouseenter':
          on('mouseleave', onMouseLeave);
          break;

        case 'focus':
          on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
          break;

        case 'focusin':
          on('focusout', onBlurOrFocusOut);
          break;
      }
    });
  }

  function removeListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function onTrigger(event) {
    var _lastTriggerEvent;

    var shouldScheduleClickHide = false;

    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }

    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();

    if (!instance.state.isVisible && isMouseEvent(event)) {
      // If scrolling, `mouseenter` events can be fired if the cursor lands
      // over a new target, but `mousemove` events don't get fired. This
      // causes interactive tooltips to get stuck open until the cursor is
      // moved
      mouseMoveListeners.forEach(function (listener) {
        return listener(event);
      });
    } // Toggle show/hide when clicking click-triggered tooltips


    if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }

    if (event.type === 'click') {
      isVisibleFromClick = !shouldScheduleClickHide;
    }

    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }

  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

    if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
      return;
    }

    var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
      var _instance$popperInsta;

      var instance = popper._tippy;
      var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

      if (state) {
        return {
          popperRect: popper.getBoundingClientRect(),
          popperState: state,
          props: props
        };
      }

      return null;
    }).filter(Boolean);

    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }

  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

    if (shouldBail) {
      return;
    }

    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }

    scheduleHide(event);
  }

  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
      return;
    } // If focus was moved to within the popper


    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide(event);
  }

  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
  }

  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props,
        popperOptions = _instance$props2.popperOptions,
        placement = _instance$props2.placement,
        offset = _instance$props2.offset,
        getReferenceClientRect = _instance$props2.getReferenceClientRect,
        moveTransition = _instance$props2.moveTransition;
    var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference;
    var tippyModifier = {
      name: '$$tippy',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
              box = _getDefaultTemplateCh.box;

          ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
            if (attr === 'placement') {
              box.setAttribute('data-placement', state.placement);
            } else {
              if (state.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, '');
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: 'flip',
      options: {
        padding: 5
      }
    }, {
      name: 'computeStyles',
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];

    if (getIsDefaultRenderFn() && arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: arrow,
          padding: 3
        }
      });
    }

    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = createPopper(computedReference, popper, Object.assign({}, popperOptions, {
      placement: placement,
      onFirstUpdate: onFirstUpdate,
      modifiers: modifiers
    }));
  }

  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }

  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
    // it's directly after the reference element so the elements inside the
    // tippy can be tabbed to
    // If there are clipping issues, the user can specify a different appendTo
    // and ensure focus management is handled correctly manually

    var node = getCurrentTarget();

    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
    } // The popper element needs to exist on the DOM before its position can be
    // updated as Popper needs to read its dimensions


    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
    }

    instance.state.isMounted = true;
    createPopperInstance();
    /* istanbul ignore else */

    if (process.env.NODE_ENV !== "production") {
      // Accessibility check
      warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
    }
  }

  function getNestedPopperTree() {
    return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
  }

  function scheduleShow(event) {
    instance.clearDelayTimeouts();

    if (event) {
      invokeHook('onTrigger', [instance, event]);
    }

    addDocumentPress();
    var delay = getDelay(true);

    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
        touchValue = _getNormalizedTouchSe[0],
        touchDelay = _getNormalizedTouchSe[1];

    if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
      delay = touchDelay;
    }

    if (delay) {
      showTimeout = setTimeout(function () {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }

  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook('onUntrigger', [instance, event]);

    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    } // For interactive tippies, scheduleHide is added to a document.body handler
    // from onMouseLeave so must intercept scheduled hides from mousemove/leave
    // events when trigger contains mouseenter and click, and the tip is
    // currently shown as a result of a click.


    if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }

    var delay = getDelay(false);

    if (delay) {
      hideTimeout = setTimeout(function () {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      scheduleHideAnimationFrame = requestAnimationFrame(function () {
        instance.hide();
      });
    }
  } // ===========================================================================
  // 🔑 Public methods
  // ===========================================================================


  function enable() {
    instance.state.isEnabled = true;
  }

  function disable() {
    // Disabling the instance should also hide it
    // https://github.com/atomiks/tippy.js-react/issues/106
    instance.hide();
    instance.state.isEnabled = false;
  }

  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }

  function setProps(partialProps) {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    invokeHook('onBeforeUpdate', [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();

    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
    } // Ensure stale aria-expanded attributes are removed


    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
        node.removeAttribute('aria-expanded');
      });
    } else if (nextProps.triggerTarget) {
      reference.removeAttribute('aria-expanded');
    }

    handleAriaExpandedAttribute();
    handleStyles();

    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }

    if (instance.popperInstance) {
      createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
      // and the nested ones get re-rendered first.
      // https://github.com/atomiks/tippyjs-react/issues/177
      // TODO: find a cleaner / more efficient solution(!)

      getNestedPopperTree().forEach(function (nestedPopper) {
        // React (and other UI libs likely) requires a rAF wrapper as it flushes
        // its work in one
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }

    invokeHook('onAfterUpdate', [instance, partialProps]);
  }

  function setContent(content) {
    instance.setProps({
      content: content
    });
  }

  function show() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
    } // Early bail-out


    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    } // Normalize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.


    if (getCurrentTarget().hasAttribute('disabled')) {
      return;
    }

    invokeHook('onShow', [instance], false);

    if (instance.props.onShow(instance) === false) {
      return;
    }

    instance.state.isVisible = true;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'visible';
    }

    handleStyles();
    addDocumentPress();

    if (!instance.state.isMounted) {
      popper.style.transition = 'none';
    } // If flipping to the opposite side after hiding at least once, the
    // animation will use the wrong placement without resetting the duration


    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh2.box,
          content = _getDefaultTemplateCh2.content;

      setTransitionDuration([box, content], 0);
    }

    onFirstUpdate = function onFirstUpdate() {
      var _instance$popperInsta2;

      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }

      ignoreOnFirstUpdate = true; // reflow

      void popper.offsetHeight;
      popper.style.transition = instance.props.moveTransition;

      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
            _box = _getDefaultTemplateCh3.box,
            _content = _getDefaultTemplateCh3.content;

        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], 'visible');
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
      // popper has been positioned for the first time

      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook('onMount', [instance]);

      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function () {
          instance.state.isShown = true;
          invokeHook('onShown', [instance]);
        });
      }
    };

    mount();
  }

  function hide() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
    } // Early bail-out


    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }

    invokeHook('onHide', [instance], false);

    if (instance.props.onHide(instance) === false) {
      return;
    }

    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'hidden';
    }

    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh4.box,
          content = _getDefaultTemplateCh4.content;

      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], 'hidden');
      }
    }

    handleAriaContentAttribute();
    handleAriaExpandedAttribute();

    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }

  function hideWithInteractivity(event) {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
    }

    getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }

  function unmount() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
    }

    if (instance.state.isVisible) {
      instance.hide();
    }

    if (!instance.state.isMounted) {
      return;
    }

    destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
    // tree by default. This seems mainly for interactive tippies, but we should
    // find a workaround if possible

    getNestedPopperTree().forEach(function (nestedPopper) {
      nestedPopper._tippy.unmount();
    });

    if (popper.parentNode) {
      popper.parentNode.removeChild(popper);
    }

    mountedInstances = mountedInstances.filter(function (i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook('onHidden', [instance]);
  }

  function destroy() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference._tippy;
    instance.state.isDestroyed = true;
    invokeHook('onDestroy', [instance]);
  }
}

function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }

  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  /* istanbul ignore else */

  if (process.env.NODE_ENV !== "production") {
    validateTargets(targets);
    validateProps(optionalProps, plugins);
  }

  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins: plugins
  });
  var elements = getArrayOfElements(targets);
  /* istanbul ignore else */

  if (process.env.NODE_ENV !== "production") {
    var isSingleContentElement = isElement(passedProps.content);
    var isMoreThanOneReferenceElement = elements.length > 1;
    warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
  }

  var instances = elements.reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, passedProps);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return isElement(targets) ? instances[0] : instances;
}

tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;

// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.

Object.assign({}, applyStyles$1, {
  effect: function effect(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    } // intentionally return no cleanup function
    // return () => { ... }

  }
});

tippy.setDefaultProps({
  render: render
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
function preserveRef(ref, node) {
  if (ref) {
    if (typeof ref === 'function') {
      ref(node);
    }

    if ({}.hasOwnProperty.call(ref, 'current')) {
      ref.current = node;
    }
  }
}
function ssrSafeCreateDiv() {
  return isBrowser && document.createElement('div');
}
function toDataAttributes(attrs) {
  var dataAttrs = {
    'data-placement': attrs.placement
  };

  if (attrs.referenceHidden) {
    dataAttrs['data-reference-hidden'] = '';
  }

  if (attrs.escaped) {
    dataAttrs['data-escaped'] = '';
  }

  return dataAttrs;
}

function deepEqual(x, y) {
  if (x === y) {
    return true;
  } else if (typeof x === 'object' && x != null && typeof y === 'object' && y != null) {
    if (Object.keys(x).length !== Object.keys(y).length) {
      return false;
    }

    for (var prop in x) {
      if (y.hasOwnProperty(prop)) {
        if (!deepEqual(x[prop], y[prop])) {
          return false;
        }
      } else {
        return false;
      }
    }

    return true;
  } else {
    return false;
  }
}

function uniqueByShape(arr) {
  var output = [];
  arr.forEach(function (item) {
    if (!output.find(function (outputItem) {
      return deepEqual(item, outputItem);
    })) {
      output.push(item);
    }
  });
  return output;
}
function deepPreserveProps(instanceProps, componentProps) {
  var _instanceProps$popper, _componentProps$poppe;

  return Object.assign({}, componentProps, {
    popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
      modifiers: uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
    })
  });
}

var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;
function useMutableBox(initialValue) {
  // Using refs instead of state as it's recommended to not store imperative
  // values in state due to memory problems in React(?)
  var ref = useRef();

  if (!ref.current) {
    ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
  }

  return ref.current;
}

function updateClassName(box, action, classNames) {
  classNames.split(/\s+/).forEach(function (name) {
    if (name) {
      box.classList[action](name);
    }
  });
}

var classNamePlugin = {
  name: 'className',
  defaultValue: '',
  fn: function fn(instance) {
    var box = instance.popper.firstElementChild;

    var isDefaultRenderFn = function isDefaultRenderFn() {
      var _instance$props$rende;

      return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
    };

    function add() {
      if (instance.props.className && !isDefaultRenderFn()) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn(['@tippyjs/react: Cannot use `className` prop in conjunction with', '`render` prop. Place the className on the element you are', 'rendering.'].join(' '));
        }

        return;
      }

      updateClassName(box, 'add', instance.props.className);
    }

    function remove() {
      if (isDefaultRenderFn()) {
        updateClassName(box, 'remove', instance.props.className);
      }
    }

    return {
      onCreate: add,
      onBeforeUpdate: remove,
      onAfterUpdate: add
    };
  }
};

function TippyGenerator(tippy) {
  function Tippy(_ref) {
    var children = _ref.children,
        content = _ref.content,
        visible = _ref.visible,
        singleton = _ref.singleton,
        render = _ref.render,
        reference = _ref.reference,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        _ref$ignoreAttributes = _ref.ignoreAttributes,
        ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes;
        _ref.__source;
        _ref.__self;
        var restOfNativeProps = _objectWithoutPropertiesLoose(_ref, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]);

    var isControlledMode = visible !== undefined;
    var isSingletonMode = singleton !== undefined;

    var _useState = useState(false),
        mounted = _useState[0],
        setMounted = _useState[1];

    var _useState2 = useState({}),
        attrs = _useState2[0],
        setAttrs = _useState2[1];

    var _useState3 = useState(),
        singletonContent = _useState3[0],
        setSingletonContent = _useState3[1];

    var mutableBox = useMutableBox(function () {
      return {
        container: ssrSafeCreateDiv(),
        renders: 1
      };
    });
    var props = Object.assign({
      ignoreAttributes: ignoreAttributes
    }, restOfNativeProps, {
      content: mutableBox.container
    });

    if (isControlledMode) {
      if (process.env.NODE_ENV !== 'production') {
        ['trigger', 'hideOnClick', 'showOnCreate'].forEach(function (nativeStateProp) {
          if (props[nativeStateProp] !== undefined) {
            console.warn(["@tippyjs/react: Cannot specify `" + nativeStateProp + "` prop in", "controlled mode (`visible` prop)"].join(' '));
          }
        });
      }

      props.trigger = 'manual';
      props.hideOnClick = false;
    }

    if (isSingletonMode) {
      disabled = true;
    }

    var computedProps = props;
    var plugins = props.plugins || [];

    if (render) {
      computedProps = Object.assign({}, props, {
        plugins: isSingletonMode && singleton.data != null ? [].concat(plugins, [{
          fn: function fn() {
            return {
              onTrigger: function onTrigger(instance, event) {
                var node = singleton.data.children.find(function (_ref2) {
                  var instance = _ref2.instance;
                  return instance.reference === event.currentTarget;
                });
                instance.state.$$activeSingletonInstance = node.instance;
                setSingletonContent(node.content);
              }
            };
          }
        }]) : plugins,
        render: function render() {
          return {
            popper: mutableBox.container
          };
        }
      });
    }

    var deps = [reference].concat(children ? [children.type] : []); // CREATE

    useIsomorphicLayoutEffect(function () {
      var element = reference;

      if (reference && reference.hasOwnProperty('current')) {
        element = reference.current;
      }

      var instance = tippy(element || mutableBox.ref || ssrSafeCreateDiv(), Object.assign({}, computedProps, {
        plugins: [classNamePlugin].concat(props.plugins || [])
      }));
      mutableBox.instance = instance;

      if (disabled) {
        instance.disable();
      }

      if (visible) {
        instance.show();
      }

      if (isSingletonMode) {
        singleton.hook({
          instance: instance,
          content: content,
          props: computedProps,
          setSingletonContent: setSingletonContent
        });
      }

      setMounted(true);
      return function () {
        instance.destroy();
        singleton == null ? void 0 : singleton.cleanup(instance);
      };
    }, deps); // UPDATE

    useIsomorphicLayoutEffect(function () {
      var _instance$popperInsta;

      // Prevent this effect from running on 1st render
      if (mutableBox.renders === 1) {
        mutableBox.renders++;
        return;
      }

      var instance = mutableBox.instance;
      instance.setProps(deepPreserveProps(instance.props, computedProps)); // Fixes #264

      (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.forceUpdate();

      if (disabled) {
        instance.disable();
      } else {
        instance.enable();
      }

      if (isControlledMode) {
        if (visible) {
          instance.show();
        } else {
          instance.hide();
        }
      }

      if (isSingletonMode) {
        singleton.hook({
          instance: instance,
          content: content,
          props: computedProps,
          setSingletonContent: setSingletonContent
        });
      }
    });
    useIsomorphicLayoutEffect(function () {
      var _instance$props$poppe;

      if (!render) {
        return;
      }

      var instance = mutableBox.instance;
      instance.setProps({
        popperOptions: Object.assign({}, instance.props.popperOptions, {
          modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function (_ref3) {
            var name = _ref3.name;
            return name !== '$$tippyReact';
          }), [{
            name: '$$tippyReact',
            enabled: true,
            phase: 'beforeWrite',
            requires: ['computeStyles'],
            fn: function fn(_ref4) {
              var _state$modifiersData;

              var state = _ref4.state;
              var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
              // loop. This expression _must_ evaluate to false when required

              if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) {
                setAttrs({
                  placement: state.placement,
                  referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                  escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                });
              }

              state.attributes.popper = {};
            }
          }])
        })
      });
    }, [attrs.placement, attrs.referenceHidden, attrs.escaped].concat(deps));
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children ? /*#__PURE__*/cloneElement(children, {
      ref: function ref(node) {
        mutableBox.ref = node;
        preserveRef(children.ref, node);
      }
    }) : null, mounted && /*#__PURE__*/createPortal(render ? render(toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
  }

  return Tippy;
}

var forwardRef = (function (Tippy, defaultProps) {
  return /*#__PURE__*/forwardRef$1(function TippyWrapper(_ref, _ref2) {
    var children = _ref.children,
        props = _objectWithoutPropertiesLoose(_ref, ["children"]);

    return (
      /*#__PURE__*/
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      React__default.createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/cloneElement(children, {
        ref: function ref(node) {
          preserveRef(_ref2, node);
          preserveRef(children.ref, node);
        }
      }) : null)
    );
  });
});
var index = /*#__PURE__*/forwardRef( /*#__PURE__*/TippyGenerator(tippy));

function getRegionalLocale(langCode, requestedLocales) {
  var locales = requestedLocales || [];
  var supportedRegionalLocales = SUPPORTED_REGION_LOCALES[langCode] || [];
  if (!locales.length || !supportedRegionalLocales.length) {
    return langCode;
  }
  for (var i = 0; i < locales.length; i++) {
    var requestedLocale = (locales[i] || '').toLowerCase();
    if (supportedRegionalLocales.includes(requestedLocale)) {
      return requestedLocale;
    }
    var _requestedLocale$spli = requestedLocale.split('-'),
      _requestedLocale$spli2 = _slicedToArray(_requestedLocale$spli, 1),
      reqLangCode = _requestedLocale$spli2[0];

    // if we stumble upon an unsupported locale of the requested language,
    // we assume the default language and return immediatly langCode
    // this makes sure en-US is treated as defacto standard and isn't
    // overwritten by a low-prio preference of en-CA or en-GB
    if (reqLangCode === langCode) {
      return langCode;
    }
  }
  return langCode;
}
function getMoment(possibleMoment) {
  if (!moment.isMoment(possibleMoment)) {
    return moment(possibleMoment);
  }
  return possibleMoment;
}

// to avoid conflict with languages that have characters in the numbers
function setEnLocaleDate(date) {
  return moment(date).locale('en');
}
function isInclusivelyAfterDay(firstDate, secondDate) {
  return !getMoment(firstDate).isBefore(getMoment(secondDate), 'day');
}
function isAfter(firstDate, secondDate) {
  return getMoment(firstDate).isAfter(getMoment(secondDate), 'day');
}
function isSameOrAfter(firstDate, secondDate) {
  return getMoment(firstDate).isSameOrAfter(secondDate);
}
function isBefore(firstDate, secondDate) {
  return getMoment(firstDate).isBefore(getMoment(secondDate), 'day');
}
function addDays(date, days) {
  return getMoment(date).clone().add(days, 'days');
}
function isBetweenDates(day, firstDate, secondDate) {
  var inclusivity = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '[]';
  return getMoment(day).isBetween(getMoment(firstDate), getMoment(secondDate), 'day', inclusivity);
}
function isSameDay(firstDate, secondDate) {
  return getMoment(firstDate).isSame(secondDate, 'day');
}
function formatDate(date) {
  return getMoment(date).format('YYYY-MM-DD');
}
function getCalendarDayQaData(isQA, day, type) {
  if (isQA) {
    return {
      'data-test-calendar-day': formatDate(day),
      'data-test-calendar-day-type': type
    };
  }
  return {};
}
function daysBetween(firstDate, secondDate) {
  var days = moment(firstDate).startOf('day').diff(moment(secondDate).startOf('day'), 'days');
  return days > 0 ? days : 1;
}

/**
 * A day that is departure only cannot be chosen as checkin, so if this is the first bookeable day it must appear as closed.
 *
 * @param {momentObj} day - current day
 * @param {momentObj} start - first day of the range unavailable
 * @param {momentObj}  firstDayExceedMinLos
 */
function shouldFirstDepartureDateBeClosed(day, start, firstDayExceedMinLos) {
  return isSameDay(day, start) && isSameOrAfter(firstDayExceedMinLos, day);
}
function formatNumber(number, language) {
  return !language || !number ? '' : new Intl.NumberFormat(language).format(number);
}
function isPriceInteger(price) {
  return price % 1 === 0;
}
function getDecimalNumbers(price) {
  return price === null || price === void 0 ? void 0 : price.toString().split('.')[1];
}
function getIntegerNumbers(price, locale) {
  var integerPart = price === null || price === void 0 ? void 0 : price.toString().split('.')[0];
  return formatNumber(integerPart, locale);
}
function getRoundingPrice(price, locale) {
  var integerPart = Math.round(price);
  return formatNumber(integerPart, locale);
}
function hasDayPriceFormatted(price) {
  return price === null || price === void 0 ? void 0 : price.toString().toLowerCase().includes('k');
}

var Placeholder = function Placeholder(_ref) {
  var onMount = _ref.onMount,
    rendered = _ref.rendered;
  useEffect(function () {
    var timeoutId;
    if (rendered) {
      onMount();
    } else {
      timeoutId = setTimeout(function () {
        return onMount();
      }, 250);
    }
    return function () {
      clearTimeout(timeoutId);
    };
  }, [onMount, rendered]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-day-wrapper"
  }, /*#__PURE__*/React__default.createElement(LoadingBlock, {
    width: "50%"
  }));
};
Placeholder.propTypes = {
  onMount: PropTypes.func.isRequired,
  rendered: PropTypes.bool.isRequired
};
var LazyDayTippy = forwardRef$1(function (props, ref) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    rendered = _useState4[0],
    setRendered = _useState4[1];
  var lazyPlugin = {
    fn: function fn() {
      return {
        onMount: function onMount() {
          return setMounted(true);
        },
        onHidden: function onHidden() {
          return setMounted(false);
        }
      };
    }
  };
  var onMountCb = useCallback(function () {
    setMounted(true);
    setRendered(true);
  });
  var computedProps = _objectSpread2({}, props);
  computedProps.plugins = [lazyPlugin].concat(_toConsumableArray(props.plugins || []));
  if (props.render) {
    computedProps.render = function () {
      return mounted ? props.render.apply(props, arguments) : '';
    };
  } else {
    computedProps.content = mounted ? props.content : '';
  }
  return mounted || rendered ? /*#__PURE__*/React__default.createElement(index, _extends({}, computedProps, {
    ref: ref
  })) : /*#__PURE__*/React__default.createElement(Placeholder, {
    onMount: onMountCb,
    rendered: rendered
  });
});

/**
 * Checks if the startDate is an `ARRIVAL` day, the endDate is a `DEPARTURE` day and all days inbetween are `STAY` days.
 *
 * In case the startDate is not available in the list of dayPrices (eg. when switching over to a new calendar month),
 * we assume it's available. This is made optimistic on purpose to fail on cases where it's not bookable, but never
 * fail on cases where it is bookable.
 *
 * If the calendar is still loading or there were no days selected yet, the DONE button should be active.
 *
 * @param {{ date: string, scope: string[] }[]} dayPrices array of day price objects
 * @param {Moment} startDate
 * @param {Moment} endDate
 */
function isDoneButtonActive(dayPrices, startDate, endDate) {
  var isBetweenStartAndEndDate = function isBetweenStartAndEndDate(dayPrice) {
    return moment(dayPrice.date).isBetween(startDate, endDate, 'day', '[]');
  };
  var selectedDays = dayPrices === null || dayPrices === void 0 ? void 0 : dayPrices.filter(isBetweenStartAndEndDate);
  if (!selectedDays || selectedDays.length === 0) {
    return true;
  }
  var isLoading = selectedDays.some(function (dayPrice) {
    return dayPrice.loading;
  });
  if (isLoading) {
    return true;
  }
  var momentStartDate = moment(startDate);
  var isRangeComplete = selectedDays[0].date === momentStartDate.format('YYYY-MM-DD');
  var isFirstDayArrival = true;
  var middleDays = null;
  if (isRangeComplete) {
    middleDays = selectedDays.slice(1, -1);
    isFirstDayArrival = selectedDays[0].scope.includes('ARRIVAL');
  } else {
    middleDays = selectedDays.slice(0, -1);
  }
  var isStayPossible = middleDays.every(function (dayPrice) {
    return dayPrice.scope.includes('STAY');
  });
  var lastDay = selectedDays[selectedDays.length - 1];
  var isLastDayDeparture = lastDay.scope.includes('DEPARTURE');
  return isFirstDayArrival && isStayPossible && isLastDayDeparture;
}
function isValidPrice(priceVal) {
  if (typeof priceVal === 'number' && priceVal >= 0) {
    return true;
  }
  if (typeof priceVal === 'string') {
    var numVal = parseFloat(priceVal);
    return !isNaN(numVal) && numVal >= 0;
  }
  return false;
}
function hasDayObjValidPrice(priceDay) {
  return isValidPrice(priceDay === null || priceDay === void 0 ? void 0 : priceDay.price);
}
function isPriceDayWithDayScopeBlocked(priceDay, datePickingState, startDate) {
  var allowedScopes = priceDay.scope || [];
  var isImpliedCheckinSelection = !!startDate && priceDay.day.isBefore(startDate, 'day');
  if (datePickingState === 'SELECTING_CHECKIN' || isImpliedCheckinSelection) {
    var hasPrice = typeof priceDay.price === 'number';
    var isAvailable = typeof priceDay.available !== 'boolean' || priceDay.available;
    return !isAvailable || !hasPrice || !allowedScopes.includes('ARRIVAL');
  }
  if (datePickingState === 'SELECTING_CHECKOUT') {
    return !allowedScopes.includes('DEPARTURE');
  }
}
function isPriceDayBlocked(priceDay, datePickingState, startDate) {
  if (!priceDay) {
    return true;
  }
  var hasScopeInfo = typeof priceDay.scope !== 'undefined';
  return hasScopeInfo ? isPriceDayWithDayScopeBlocked(priceDay, datePickingState, startDate) : !hasDayObjValidPrice(priceDay);
}

var FastAvailableDayContentPriceDisplay = function FastAvailableDayContentPriceDisplay(_ref) {
  var price = _ref.price,
    locale = _ref.locale;
  var _useState = useState(hasDayPriceFormatted(price)),
    _useState2 = _slicedToArray(_useState, 2),
    isDisplayingPriceFormatted = _useState2[0],
    setIsDisplayingPriceFormatted = _useState2[1];
  var _useState3 = useState(isPriceInteger(price)),
    _useState4 = _slicedToArray(_useState3, 2),
    isFloatPrice = _useState4[0],
    setIsFloatPrice = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    priceLabel = _useState6[0],
    setPriceLabel = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    decimalNumbers = _useState8[0],
    setDecimalNumbers = _useState8[1];
  var _useState9 = useState(getRoundingPrice(price, locale)),
    _useState10 = _slicedToArray(_useState9, 2),
    roundedPrice = _useState10[0],
    setRoundedPrice = _useState10[1];
  useEffect(function () {
    setIsFloatPrice(!isPriceInteger(price));
  }, [price]);
  useEffect(function () {
    setRoundedPrice(getRoundingPrice(price, locale));
  }, [price, locale]);
  useEffect(function () {
    if (isFloatPrice) {
      setPriceLabel("".concat(getIntegerNumbers(price, locale), "."));
      setDecimalNumbers(getDecimalNumbers(price));
    } else {
      setPriceLabel(price);
    }
  }, [isFloatPrice, price]);
  useEffect(function () {
    setIsDisplayingPriceFormatted(hasDayPriceFormatted(price));
  }, [price, hasDayPriceFormatted]);
  if (isDisplayingPriceFormatted) {
    return /*#__PURE__*/React__default.createElement("span", {
      className: "formatted-number"
    }, price);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "normal-number"
  }, priceLabel, isFloatPrice ? /*#__PURE__*/React__default.createElement("span", {
    className: "decimal"
  }, decimalNumbers) : null), /*#__PURE__*/React__default.createElement("span", {
    className: "rounding-number"
  }, roundedPrice));
};
FastAvailableDayContentPriceDisplay.propTypes = {
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  locale: PropTypes.string.isRequired
};
var FastAvailableDayContentDateLabel = function FastAvailableDayContentDateLabel(_ref2) {
  var price = _ref2.price,
    formattedDay = _ref2.formattedDay;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-day-number".concat(price ? ' has-price' : '')
  }, formattedDay);
};
FastAvailableDayContentDateLabel.propTypes = {
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  formattedDay: PropTypes.string.isRequired
};
var FastAvailableDayContentPriceQualifier = function FastAvailableDayContentPriceQualifier(_ref3) {
  var priceQualifier = _ref3.priceQualifier;
  if (priceQualifier) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "bf-date-range-picker-day-price-qualifier"
    }, priceQualifier);
  }
  return null;
};
FastAvailableDayContentPriceQualifier.propTypes = {
  priceQualifier: nodeOrStringOrFuncProp.isRequired
};
var FastAvailableDayPriceContent = function FastAvailableDayPriceContent(_ref4) {
  var getNightsCountLabel = _ref4.getNightsCountLabel,
    priceQualifier = _ref4.priceQualifier,
    currencyCode = _ref4.currencyCode,
    currencySymbol = _ref4.currencySymbol,
    currencyDisplay = _ref4.currencyDisplay,
    nightsCounter = _ref4.nightsCounter,
    locale = _ref4.locale,
    price = _ref4.price,
    isStartDate = _ref4.isStartDate,
    getMinLosLabel = _ref4.getMinLosLabel,
    minLos = _ref4.minLos;
  var _useState11 = useState(currencyDisplay === 'symbol' ? currencySymbol !== null && currencySymbol !== void 0 ? currencySymbol : currencyCode : currencyCode),
    _useState12 = _slicedToArray(_useState11, 2),
    currencyToken = _useState12[0],
    setCurrencyToken = _useState12[1];
  useEffect(function () {
    setCurrencyToken(currencyDisplay === 'symbol' ? currencySymbol !== null && currencySymbol !== void 0 ? currencySymbol : currencyCode : currencyCode);
  }, [currencyCode, currencyDisplay, currencySymbol]);
  if (nightsCounter) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "bf-date-range-picker-day-night-counts"
    }, getNightsCountLabel(nightsCounter));
  }
  if (isStartDate && getMinLosLabel && minLos) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "bf-date-range-picker-day-price"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "day-price"
    }, getMinLosLabel(minLos)));
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FastAvailableDayContentPriceQualifier, {
    priceQualifier: priceQualifier
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-day-price"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bf-date-range-picker-currency-code"
  }, currencyToken), "\xA0", /*#__PURE__*/React__default.createElement("span", {
    className: "day-price"
  }, /*#__PURE__*/React__default.createElement(FastAvailableDayContentPriceDisplay, {
    price: price,
    locale: locale
  }))));
};
FastAvailableDayPriceContent.propTypes = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
  getNightsCountLabel: PropTypes.func.isRequired,
  priceQualifier: nodeOrStringOrFuncProp.isRequired,
  currencyCode: PropTypes.string,
  nightsCounter: PropTypes.number,
  locale: PropTypes.string.isRequired,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}, "currencyCode", PropTypes.string), "currencySymbol", PropTypes.string), "currencyDisplay", PropTypes.oneOf(['code', 'symbol'])), "isStartDate", PropTypes.bool), "getMinLosLabel", PropTypes.func), "minLos", PropTypes.number);
FastAvailableDayPriceContent.defaultProps = {
  currencyCode: '',
  currencyDisplay: 'code',
  currencySymbol: '',
  isStartDate: false,
  nightsCounter: null,
  getMinLosLabel: null,
  minLos: null
};
var FastAvailableDayContent = function FastAvailableDayContent(_ref5) {
  var isLoading = _ref5.isLoading,
    showPrice = _ref5.showPrice,
    locale = _ref5.locale,
    currencySymbol = _ref5.currencySymbol,
    currencyDisplay = _ref5.currencyDisplay,
    formattedDay = _ref5.formattedDay,
    price = _ref5.price,
    nightsCounter = _ref5.nightsCounter,
    getNightsCountLabel = _ref5.getNightsCountLabel,
    currencyCode = _ref5.currencyCode,
    priceQualifier = _ref5.priceQualifier,
    isStartDate = _ref5.isStartDate,
    getMinLosLabel = _ref5.getMinLosLabel,
    minLos = _ref5.minLos;
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(LoadingBlock, {
      width: "50%"
    });
  }
  if (!showPrice || !isValidPrice(price)) {
    return /*#__PURE__*/React__default.createElement("span", {
      className: "bf-date-range-picker-day"
    }, formattedDay);
  }
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FastAvailableDayContentDateLabel, {
    formattedDay: formattedDay,
    price: price
  }), /*#__PURE__*/React__default.createElement(FastAvailableDayPriceContent, {
    priceQualifier: priceQualifier,
    nightsCounter: nightsCounter,
    getNightsCountLabel: getNightsCountLabel,
    locale: locale,
    price: price,
    currencyCode: currencyCode,
    currencyDisplay: currencyDisplay,
    currencySymbol: currencySymbol,
    isStartDate: isStartDate,
    getMinLosLabel: getMinLosLabel,
    minLos: minLos
  }));
};
FastAvailableDayContent.propTypes = _defineProperty({
  getNightsCountLabel: PropTypes.func.isRequired,
  priceQualifier: nodeOrStringOrFuncProp.isRequired,
  currencyCode: PropTypes.string,
  nightsCounter: PropTypes.number,
  locale: PropTypes.string.isRequired,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool.isRequired,
  showPrice: PropTypes.bool.isRequired,
  formattedDay: PropTypes.string.isRequired,
  currencyDisplay: PropTypes.oneOf(['code', 'symbol']),
  currencySymbol: PropTypes.string,
  isStartDate: PropTypes.bool,
  getMinLosLabel: PropTypes.func,
  minLos: PropTypes.number
}, "currencyCode", PropTypes.string);
FastAvailableDayContent.defaultProps = {
  currencyCode: '',
  currencySymbol: '',
  currencyDisplay: 'code',
  isStartDate: false,
  nightsCounter: null,
  price: null
};
var FastAvailableDay = function FastAvailableDay(props) {
  var day = props.day,
    isSelectingCheckin = props.isSelectingCheckin,
    isQA = props.isQA,
    tooltipContent = props.tooltipContent,
    calculateNightsOnHover = props.calculateNightsOnHover,
    showPrice = props.showPrice,
    currencyCode = props.currencyCode,
    price = props.price,
    locale = props.locale,
    isLoading = props.isLoading,
    priceQualifier = props.priceQualifier,
    nightsCounter = props.nightsCounter,
    getNightsCountLabel = props.getNightsCountLabel,
    currencySymbol = props.currencySymbol,
    currencyDisplay = props.currencyDisplay,
    isStartDate = props.isStartDate,
    getMinLosLabel = props.getMinLosLabel,
    minLos = props.minLos,
    isDayAllowedForCheckout = props.isDayAllowedForCheckout;
  var _useState13 = useState(day === null || day === void 0 ? void 0 : day.format('D')),
    _useState14 = _slicedToArray(_useState13, 2),
    formattedDay = _useState14[0],
    setFormattedDay = _useState14[1];
  var _useState15 = useState(day === null || day === void 0 ? void 0 : day.format('YYYY-MM-DD')),
    _useState16 = _slicedToArray(_useState15, 2),
    formattedDate = _useState16[0],
    setFormattedDate = _useState16[1];
  var appendTo = useCallback(function () {
    return document.querySelector('.bf-date-range-picker-main-wrapper');
  });
  var qaData = getCalendarDayQaData(isQA, day, 'available');
  var notAllowedForCheckoutClass = !isSelectingCheckin && !isDayAllowedForCheckout ? 'not-allowed-for-checkout' : '';
  useEffect(function () {
    if (day) {
      setFormattedDay(day.format('D'));
      setFormattedDate(day.format('YYYY-MM-DD'));
    }
  }, [day]);
  return /*#__PURE__*/React__default.createElement(LazyDayTippy, {
    theme: "light",
    disabled: isSelectingCheckin || !tooltipContent(day),
    content: tooltipContent(day),
    hideOnClick: false,
    appendTo: appendTo,
    className: "bf-date-range-picker-calendar-day-tooltip"
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    "data-calendar-day": formattedDate,
    className: "bf-date-range-picker-day-wrapper ".concat(notAllowedForCheckoutClass)
    // tried to setup a callback which is changed on day change,
    // but day did not update correctly, so had to use the arrow func
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onMouseOver: function onMouseOver() {
      return calculateNightsOnHover(day);
    }
  }, qaData), /*#__PURE__*/React__default.createElement(FastAvailableDayContent, {
    isLoading: isLoading,
    formattedDay: formattedDay,
    price: price,
    showPrice: showPrice,
    nightsCounter: nightsCounter,
    getNightsCountLabel: getNightsCountLabel,
    priceQualifier: priceQualifier,
    locale: locale,
    currencyDisplay: currencyDisplay,
    currencyCode: currencyCode,
    currencySymbol: currencySymbol,
    isStartDate: isStartDate,
    getMinLosLabel: getMinLosLabel,
    minLos: minLos
  })));
};
FastAvailableDay.propTypes = {
  getNightsCountLabel: PropTypes.func.isRequired,
  priceQualifier: nodeOrStringOrFuncProp.isRequired,
  currencyCode: PropTypes.string,
  currencyDisplay: PropTypes.oneOf(['code', 'symbol']),
  currencySymbol: PropTypes.string,
  nightsCounter: PropTypes.number,
  locale: PropTypes.string.isRequired,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool,
  showPrice: PropTypes.bool.isRequired,
  day: src.momentObj.isRequired,
  isSelectingCheckin: PropTypes.bool,
  isQA: PropTypes.bool,
  tooltipContent: PropTypes.func.isRequired,
  calculateNightsOnHover: PropTypes.func,
  isStartDate: PropTypes.bool,
  getMinLosLabel: PropTypes.func,
  minLos: PropTypes.number,
  isDayAllowedForCheckout: PropTypes.bool
};
FastAvailableDay.defaultProps = {
  isQA: false,
  isSelectingCheckin: false,
  calculateNightsOnHover: function calculateNightsOnHover() {},
  currencyCode: '',
  currencySymbol: '',
  currencyDisplay: 'code',
  isStartDate: false,
  isDayAllowedForCheckout: false,
  nightsCounter: null,
  price: null,
  isLoading: false
};
var BlockedDay = function BlockedDay(props) {
  var day = props.day,
    isQA = props.isQA,
    tooltipContent = props.tooltipContent,
    isSelectingCheckin = props.isSelectingCheckin,
    calculateNightsOnHover = props.calculateNightsOnHover;
  var qaData = getCalendarDayQaData(isQA, day, 'blocked');
  return /*#__PURE__*/React__default.createElement(index, {
    theme: "light",
    disabled: isSelectingCheckin || !tooltipContent(day),
    content: tooltipContent(day),
    hideOnClick: false
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    className: "bf-date-range-picker-day-wrapper not-available",
    onMouseOver: function onMouseOver() {
      return calculateNightsOnHover(day);
    }
  }, qaData), /*#__PURE__*/React__default.createElement("span", {
    className: "bf-date-range-picker-day"
  }, day.format('D')), /*#__PURE__*/React__default.createElement("span", {
    className: "bf-date-range-picker-day-reference-background"
  })));
};
BlockedDay.defaultProps = {
  isQA: false
};
BlockedDay.propTypes = {
  day: src.momentObj.isRequired,
  isQA: PropTypes.bool,
  isSelectingCheckin: PropTypes.bool.isRequired,
  tooltipContent: PropTypes.func.isRequired,
  calculateNightsOnHover: PropTypes.func.isRequired
};
var DepartureDay = function DepartureDay(props) {
  var day = props.day,
    isQA = props.isQA,
    tooltipContent = props.tooltipContent,
    isSelectingCheckin = props.isSelectingCheckin,
    calculateNightsOnHover = props.calculateNightsOnHover;
  var qaData = getCalendarDayQaData(isQA, day, 'departure');
  return /*#__PURE__*/React__default.createElement(index, {
    theme: "light",
    disabled: isSelectingCheckin || !tooltipContent(day),
    content: tooltipContent(day),
    hideOnClick: false
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    className: "bf-date-range-picker-day-wrapper closed-to-arrival",
    onMouseOver: function onMouseOver() {
      return calculateNightsOnHover(day);
    }
  }, qaData), /*#__PURE__*/React__default.createElement("span", {
    className: "bf-date-range-picker-day"
  }, day.format('D')), /*#__PURE__*/React__default.createElement("span", {
    className: "bf-date-range-picker-day-reference-background"
  })));
};
DepartureDay.defaultProps = {
  isQA: false
};
DepartureDay.propTypes = {
  day: src.momentObj.isRequired,
  isQA: PropTypes.bool,
  isSelectingCheckin: PropTypes.bool.isRequired,
  tooltipContent: PropTypes.func.isRequired,
  calculateNightsOnHover: PropTypes.func.isRequired
};

var DeparturesOnlyReference = function DeparturesOnlyReference(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-day-reference-wrapper closed-to-arrival-reference-wrapper"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bf-date-range-picker-blocked-day-reference closed-to-arrival"
  }), /*#__PURE__*/React__default.createElement("small", {
    className: "bf-date-range-picker-blocked-day-reference-label"
  }, label));
};
var NotAvailableReference = function NotAvailableReference(_ref2) {
  var label = _ref2.label;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-day-reference-wrapper not-available-reference-wrapper"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bf-date-range-picker-blocked-day-reference not-available"
  }), /*#__PURE__*/React__default.createElement("small", {
    className: "bf-date-range-picker-blocked-day-reference-label"
  }, label));
};
DeparturesOnlyReference.propTypes = {
  label: PropTypes.string.isRequired
};
({
  label: PropTypes.string.isRequired
});
NotAvailableReference.propTypes = {
  label: PropTypes.string.isRequired
};

function Footer(props) {
  var showBlockedDaysReferences = props.showBlockedDaysReferences,
    departureOnlyLabel = props.departureOnlyLabel,
    noAvailabilityLabel = props.noAvailabilityLabel,
    getNightsCountLabel = props.getNightsCountLabel,
    nightsCounter = props.nightsCounter,
    startDate = props.startDate,
    endDate = props.endDate,
    doneButtonLabel = props.doneButtonLabel,
    resetButtonLabel = props.resetButtonLabel,
    handleDoneButton = props.handleDoneButton,
    handleResetButton = props.handleResetButton,
    showResetButton = props.showResetButton;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-footer"
  }, showBlockedDaysReferences ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-references-wrapper"
  }, /*#__PURE__*/React__default.createElement(DeparturesOnlyReference, {
    label: departureOnlyLabel
  }), /*#__PURE__*/React__default.createElement(NotAvailableReference, {
    label: noAvailabilityLabel
  })) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-footer-main-area"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-nights-count"
  }, getNightsCountLabel(nightsCounter)), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-confirmation-button-wrapper"
  }, showResetButton ? /*#__PURE__*/React__default.createElement(Button, {
    secondary: true,
    disabled: !startDate || !endDate,
    content: resetButtonLabel,
    onClick: handleResetButton,
    className: "bf-date-range-picker-reset-button"
  }) : null, /*#__PURE__*/React__default.createElement(Button, {
    primary: true,
    disabled: !startDate || !endDate,
    content: doneButtonLabel,
    onClick: handleDoneButton,
    className: "bf-date-range-picker-confirmation-button"
  }))));
}
Footer.defaultProps = {
  startDate: null,
  endDate: null,
  doneButtonLabel: 'Done',
  resetButtonLabel: 'Reset'
};
Footer.propTypes = {
  showBlockedDaysReferences: PropTypes.bool.isRequired,
  departureOnlyLabel: nodeOrStringProp.isRequired,
  noAvailabilityLabel: nodeOrStringProp.isRequired,
  getNightsCountLabel: PropTypes.func.isRequired,
  nightsCounter: PropTypes.number.isRequired,
  handleDoneButton: PropTypes.func.isRequired,
  handleResetButton: PropTypes.func.isRequired,
  showResetButton: PropTypes.bool.isRequired,
  startDate: src.momentObj,
  endDate: src.momentObj,
  doneButtonLabel: nodeOrStringProp,
  resetButtonLabel: nodeOrStringProp
};

var OptionalButton = function OptionalButton(_ref) {
  var showButton = _ref.showButton,
    disabled = _ref.disabled,
    content = _ref.content,
    onClick = _ref.onClick,
    style = _ref.style;
  if (!showButton) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Button, {
    primary: style === 'primary',
    secondary: style === 'secondary',
    transparent: style === 'transparent',
    disabled: disabled,
    content: content,
    onClick: onClick
  });
};
OptionalButton.propTypes = {
  showButton: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  content: nodeOrStringProp.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.oneOf(['primary', 'secondary', 'transparent'])
};
OptionalButton.defaultProps = {
  primary: false,
  secondary: false
};
var AvailabilityCalendarFooter = function AvailabilityCalendarFooter(_ref2) {
  var showBlockedDaysReferences = _ref2.showBlockedDaysReferences,
    departureOnlyLabel = _ref2.departureOnlyLabel,
    noAvailabilityLabel = _ref2.noAvailabilityLabel,
    getNightsCountLabel = _ref2.getNightsCountLabel,
    nightsCounter = _ref2.nightsCounter,
    startDate = _ref2.startDate,
    endDate = _ref2.endDate,
    getDoneButtonLabel = _ref2.getDoneButtonLabel,
    resetButtonLabel = _ref2.resetButtonLabel,
    handleDoneButton = _ref2.handleDoneButton,
    handleResetButton = _ref2.handleResetButton,
    showResetButton = _ref2.showResetButton;
  var onDoneClick = useCallback(function () {
    handleDoneButton(true);
  }, [handleDoneButton]);
  var onResetClick = useCallback(function () {
    handleResetButton();
  }, [handleResetButton]);
  return /*#__PURE__*/React__default.createElement(Footer, {
    showBlockedDaysReferences: showBlockedDaysReferences,
    departureOnlyLabel: departureOnlyLabel,
    noAvailabilityLabel: noAvailabilityLabel,
    getNightsCountLabel: getNightsCountLabel,
    nightsCounter: nightsCounter,
    startDate: startDate,
    endDate: endDate,
    doneButtonLabel: getDoneButtonLabel(),
    resetButtonLabel: resetButtonLabel,
    showResetButton: showResetButton,
    handleDoneButton: onDoneClick,
    handleResetButton: onResetClick
  });
};
AvailabilityCalendarFooter.propTypes = {
  showBlockedDaysReferences: PropTypes.bool.isRequired,
  departureOnlyLabel: PropTypes.string.isRequired,
  noAvailabilityLabel: PropTypes.string.isRequired,
  getNightsCountLabel: PropTypes.func.isRequired,
  nightsCounter: PropTypes.number.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  handleDoneButton: PropTypes.func.isRequired,
  handleResetButton: PropTypes.func.isRequired,
  getDoneButtonLabel: PropTypes.func.isRequired,
  resetButtonLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  showResetButton: PropTypes.bool.isRequired
};
function TaxInfoDisplay(_ref3) {
  var taxInfoLabel = _ref3.taxInfoLabel;
  if (!taxInfoLabel) {
    return null;
  }
  if (typeof taxInfoLabel === 'string') {
    return ". ".concat(taxInfoLabel);
  }
  if (typeof taxInfoLabel === 'function') {
    return '. ' + taxInfoLabel();
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, ". ", taxInfoLabel);
}
TaxInfoDisplay.propTypes = {
  taxInfoLabel: nodeOrStringOrFuncProp
};
TaxInfoDisplay.defaultProps = {
  taxInfoLabel: null
};
var PriceCalendarFooter = function PriceCalendarFooter(_ref4) {
  var hidePriceCalendarOnSelect = _ref4.hidePriceCalendarOnSelect,
    priceDisplayMode = _ref4.priceDisplayMode,
    taxInfoLabel = _ref4.taxInfoLabel,
    checkOutSummary = _ref4.checkOutSummary,
    datePickingState = _ref4.datePickingState,
    endDate = _ref4.endDate,
    startDate = _ref4.startDate,
    getDoneButtonLabel = _ref4.getDoneButtonLabel,
    handleDoneButton = _ref4.handleDoneButton,
    cancelButtonLabel = _ref4.cancelButtonLabel,
    handleCancelButton = _ref4.handleCancelButton,
    showCancelButton = _ref4.showCancelButton,
    resetButtonLabel = _ref4.resetButtonLabel,
    handleResetButton = _ref4.handleResetButton,
    showResetButton = _ref4.showResetButton;
  var _useState = useState(datePickingState === 'SELECTING_CHECKIN' && !endDate),
    _useState2 = _slicedToArray(_useState, 2),
    isCancelButtonDisabled = _useState2[0],
    setIsCancelButtonDisabled = _useState2[1];
  var _useState3 = useState(!startDate || !endDate),
    _useState4 = _slicedToArray(_useState3, 2),
    isDoneButtonDisabled = _useState4[0],
    setIsDoneButtonDisabled = _useState4[1];
  var _useState5 = useState(!startDate || !endDate),
    _useState6 = _slicedToArray(_useState5, 2),
    isResetButtonDisabled = _useState6[0];
    _useState6[1];
  useEffect(function () {
    setIsCancelButtonDisabled(datePickingState === 'SELECTING_CHECKIN' && !endDate);
  }, [datePickingState, endDate]);
  useEffect(function () {
    setIsDoneButtonDisabled(!startDate || !endDate);
  }, [startDate, endDate]);
  var onDoneClick = useCallback(function () {
    handleDoneButton(hidePriceCalendarOnSelect);
  }, [hidePriceCalendarOnSelect, handleDoneButton]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-price-footer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-price-footer-info"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tax-price-summary-info"
  }, priceDisplayMode, /*#__PURE__*/React__default.createElement(TaxInfoDisplay, {
    taxInfoLabel: taxInfoLabel
  })), checkOutSummary), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-buttons"
  }, /*#__PURE__*/React__default.createElement(OptionalButton, {
    showButton: showCancelButton,
    style: "secondary",
    disabled: isCancelButtonDisabled,
    content: cancelButtonLabel,
    onClick: handleCancelButton
  }), /*#__PURE__*/React__default.createElement(OptionalButton, {
    showButton: showResetButton,
    style: "secondary",
    disabled: isResetButtonDisabled,
    content: resetButtonLabel,
    onClick: handleResetButton
  }), /*#__PURE__*/React__default.createElement(OptionalButton, {
    showButton: !!endDate,
    style: "primary",
    disabled: isDoneButtonDisabled,
    content: getDoneButtonLabel(),
    onClick: onDoneClick
  })));
};
PriceCalendarFooter.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  priceDisplayMode: nodeOrStringProp,
  checkOutSummary: PropTypes.node,
  datePickingState: PropTypes.string,
  hidePriceCalendarOnSelect: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  showResetButton: PropTypes.bool,
  handleDoneButton: PropTypes.func,
  handleCancelButton: PropTypes.func,
  handleResetButton: PropTypes.func,
  getDoneButtonLabel: PropTypes.func,
  taxInfoLabel: PropTypes.string,
  cancelButtonLabel: nodeOrStringProp,
  resetButtonLabel: nodeOrStringProp
};
PriceCalendarFooter.defaultProps = {
  startDate: null,
  endDate: null,
  priceDisplayMode: '',
  checkOutSummary: null,
  datePickingState: '',
  hidePriceCalendarOnSelect: false,
  showCancelButton: true,
  showResetButton: true,
  handleDoneButton: function handleDoneButton() {},
  handleCancelButton: function handleCancelButton() {},
  handleResetButton: function handleResetButton() {},
  getDoneButtonLabel: function getDoneButtonLabel() {
    return '';
  },
  taxInfoLabel: '',
  cancelButtonLabel: 'Cancel',
  resetButtonLabel: 'Reset'
};
var CalendarInfoFooter = function CalendarInfoFooter(_ref5) {
  var showPrice = _ref5.showPrice,
    hidePriceCalendarOnSelect = _ref5.hidePriceCalendarOnSelect,
    handleDoneButton = _ref5.handleDoneButton,
    handleResetButton = _ref5.handleResetButton,
    priceDisplayMode = _ref5.priceDisplayMode,
    taxInfoLabel = _ref5.taxInfoLabel,
    checkOutSummary = _ref5.checkOutSummary,
    datePickingState = _ref5.datePickingState,
    cancelButtonLabel = _ref5.cancelButtonLabel,
    resetButtonLabel = _ref5.resetButtonLabel,
    handleCancelButton = _ref5.handleCancelButton,
    endDate = _ref5.endDate,
    startDate = _ref5.startDate,
    getDoneButtonLabel = _ref5.getDoneButtonLabel,
    showCancelButton = _ref5.showCancelButton,
    showBlockedDaysReferences = _ref5.showBlockedDaysReferences,
    departureOnlyLabel = _ref5.departureOnlyLabel,
    noAvailabilityLabel = _ref5.noAvailabilityLabel,
    getNightsCountLabel = _ref5.getNightsCountLabel,
    nightsCounter = _ref5.nightsCounter,
    showResetButton = _ref5.showResetButton;
  if (showPrice) {
    return /*#__PURE__*/React__default.createElement(PriceCalendarFooter, {
      startDate: startDate,
      endDate: endDate,
      priceDisplayMode: priceDisplayMode,
      checkOutSummary: checkOutSummary,
      datePickingState: datePickingState,
      hidePriceCalendarOnSelect: hidePriceCalendarOnSelect,
      showCancelButton: showCancelButton,
      showResetButton: showResetButton,
      handleDoneButton: handleDoneButton,
      handleCancelButton: handleCancelButton,
      handleResetButton: handleResetButton,
      getDoneButtonLabel: getDoneButtonLabel,
      taxInfoLabel: taxInfoLabel,
      cancelButtonLabel: cancelButtonLabel,
      resetButtonLabel: resetButtonLabel
    });
  }
  return /*#__PURE__*/React__default.createElement(AvailabilityCalendarFooter, {
    showBlockedDaysReferences: showBlockedDaysReferences,
    departureOnlyLabel: departureOnlyLabel,
    noAvailabilityLabel: noAvailabilityLabel,
    getNightsCountLabel: getNightsCountLabel,
    nightsCounter: nightsCounter,
    handleDoneButton: handleDoneButton,
    handleResetButton: handleResetButton,
    startDate: startDate,
    endDate: endDate,
    showResetButton: showResetButton,
    getDoneButtonLabel: getDoneButtonLabel,
    resetButtonLabel: resetButtonLabel
  });
};
CalendarInfoFooter.propTypes = {
  endDate: PropTypes.object,
  startDate: PropTypes.object,
  priceDisplayMode: nodeOrStringProp,
  taxInfoLabel: PropTypes.string,
  checkOutSummary: nodeOrStringProp,
  datePickingState: PropTypes.string,
  cancelButtonLabel: nodeOrStringProp,
  resetButtonLabel: nodeOrStringProp,
  departureOnlyLabel: PropTypes.string,
  noAvailabilityLabel: PropTypes.string,
  getDoneButtonLabel: PropTypes.func,
  getNightsCountLabel: PropTypes.func,
  handleDoneButton: PropTypes.func,
  handleCancelButton: PropTypes.func,
  handleResetButton: PropTypes.func,
  showPrice: PropTypes.bool,
  hidePriceCalendarOnSelect: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  showResetButton: PropTypes.bool,
  showBlockedDaysReferences: PropTypes.bool,
  nightsCounter: PropTypes.number
};
CalendarInfoFooter.defaultProps = {
  departureOnlyLabel: '',
  noAvailabilityLabel: '',
  checkOutSummary: '',
  cancelButtonLabel: 'Cancel',
  resetButtonLabel: 'Reset',
  getDoneButtonLabel: function getDoneButtonLabel() {
    return '';
  },
  getNightsCountLabel: function getNightsCountLabel() {
    return '';
  },
  handleDoneButton: function handleDoneButton() {
    return '';
  },
  handleCancelButton: function handleCancelButton() {
    return '';
  },
  handleResetButton: function handleResetButton() {
    return '';
  },
  showCancelButton: true,
  showResetButton: true,
  showBlockedDaysReferences: false,
  nightsCounter: 0
};

var DateRangePickerConstants = {
  DISPLAY_FORMAT: 'L',
  ISO_FORMAT: 'YYYY-MM-DD',
  ISO_MONTH_FORMAT: 'YYYY-MM',
  // TODO delete this line of dead code on next breaking change

  START_DATE: 'startDate',
  END_DATE: 'endDate',
  HORIZONTAL_ORIENTATION: 'horizontal',
  VERTICAL_ORIENTATION: 'vertical',
  VERTICAL_SCROLLABLE: 'verticalScrollable',
  NAV_POSITION_BOTTOM: 'navPositionBottom',
  NAV_POSITION_TOP: 'navPositionTop',
  ICON_BEFORE_POSITION: 'before',
  ICON_AFTER_POSITION: 'after',
  INFO_POSITION_TOP: 'top',
  INFO_POSITION_BOTTOM: 'bottom',
  INFO_POSITION_BEFORE: 'before',
  INFO_POSITION_AFTER: 'after',
  ANCHOR_LEFT: 'left',
  ANCHOR_RIGHT: 'right',
  OPEN_DOWN: 'down',
  OPEN_UP: 'up',
  DAY_SIZE: 39,
  BLOCKED_MODIFIER: 'blocked',
  WEEKDAYS: [0, 1, 2, 3, 4, 5, 6],
  FANG_WIDTH_PX: 20,
  FANG_HEIGHT_PX: 10,
  DEFAULT_VERTICAL_SPACING: 22,
  MODIFIER_KEY_NAMES: new Set(['Shift', 'Control', 'Alt', 'Meta']),
  // default 'en' wtis
  CHECK_IN_LABEL: 'Check in',
  CHECK_OUT_LABEL: 'Check out',
  FULLSCREEN_PORTAL_TITLE: 'Stay dates',
  NO_AVAILABILITY_LABEL: 'No availability',
  DEPARTURE_ONLY_LABEL: 'Departures only',
  ARRIVALS_ONLY_LABEL: 'Arrivals only',
  DONE_BUTTON_LABEL: 'Done',
  CANCEL_BUTTON_LABEL: 'Cancel',
  RESET_BUTTON_LABEL: 'Reset',
  TAX_INFO_LABEL: 'Including taxes and fees, except those to be paid on-site',
  NO_DEPARTURE_TOOLTIP_LABEL: 'Closed for departure',
  PRICE_QUALIFIER_LABEL: 'from'
};

var START_DATE = DateRangePickerConstants.START_DATE,
  END_DATE = DateRangePickerConstants.END_DATE,
  VERTICAL_SCROLLABLE = DateRangePickerConstants.VERTICAL_SCROLLABLE,
  HORIZONTAL_ORIENTATION = DateRangePickerConstants.HORIZONTAL_ORIENTATION,
  ARRIVALS_ONLY_LABEL = DateRangePickerConstants.ARRIVALS_ONLY_LABEL,
  CANCEL_BUTTON_LABEL = DateRangePickerConstants.CANCEL_BUTTON_LABEL,
  CHECK_IN_LABEL = DateRangePickerConstants.CHECK_IN_LABEL,
  CHECK_OUT_LABEL = DateRangePickerConstants.CHECK_OUT_LABEL,
  DEPARTURE_ONLY_LABEL = DateRangePickerConstants.DEPARTURE_ONLY_LABEL,
  NO_AVAILABILITY_LABEL = DateRangePickerConstants.NO_AVAILABILITY_LABEL,
  DONE_BUTTON_LABEL = DateRangePickerConstants.DONE_BUTTON_LABEL,
  FULLSCREEN_PORTAL_TITLE = DateRangePickerConstants.FULLSCREEN_PORTAL_TITLE,
  NO_DEPARTURE_TOOLTIP_LABEL = DateRangePickerConstants.NO_DEPARTURE_TOOLTIP_LABEL,
  RESET_BUTTON_LABEL = DateRangePickerConstants.RESET_BUTTON_LABEL,
  TAX_INFO_LABEL = DateRangePickerConstants.TAX_INFO_LABEL;
var DAY_PICKING_STATES = {
  SELECTING_CHECKIN: 'SELECTING_CHECKIN',
  SELECTING_CHECKOUT: 'SELECTING_CHECKOUT'
};
// there are three states the calendar may be in:
// 1) checkin-overview
// 2) checkin-selected
// 3) checkin-checkout-selected

function mapPricesToDayPricesMap(prices) {
  var pricesByDay = {};
  if (!(prices === null || prices === void 0 ? void 0 : prices.length)) {
    return pricesByDay;
  }
  prices.forEach(function (dayPrice) {
    pricesByDay[dayPrice.day.format('YYYY-MM-DD')] = dayPrice;
  });
  return pricesByDay;
}
function getMainWrapperClassNames(_ref) {
  var showPrice = _ref.showPrice,
    showInline = _ref.showInline,
    fullWidth = _ref.fullWidth;
  var classNames = ['bf-date-range-picker-main-wrapper'];
  if (showPrice) {
    classNames.push('price-wrapper');
  }
  if (showInline) {
    classNames.push('show-inline');
  }
  if (fullWidth) {
    classNames.push('full-width');
  }
  return classNames.join(' ');
}

/**
 * If startDate is set, this function will remove all classes starting with `CalendarDay__hovered_span`.
 * This is a workaround for a component with the react-dates component
 *
 * @param {moment} startDate selected checkin day
 * @param {moment} endDate selected checkout day (optional)
 */
function cleanUpWronglyHighlightedDays(calendarRef, startDate, endDate) {
  if (!(calendarRef === null || calendarRef === void 0 ? void 0 : calendarRef.current) || !startDate) {
    return;
  }
  var $days = calendarRef.current.querySelectorAll('div.bf-date-range-picker-day-wrapper[data-calendar-day]');
  $days.forEach(function ($day) {
    var isoDate = $day.getAttribute('data-calendar-day');
    var dateObj = moment(isoDate, 'YYYY-MM-DD');
    var classNamesForRemoval = [];
    if (dateObj.isBefore(startDate, 'day')) {
      $day.parentNode.classList.forEach(function (className) {
        var isUpForRemoval = className.startsWith('CalendarDay__hovered_span');
        if (isUpForRemoval) {
          classNamesForRemoval.push(className);
        }
      });
    } else if (!!endDate && endDate.isBefore(dateObj, 'day')) {
      $day.parentNode.classList.forEach(function (className) {
        var isUpForRemoval = className.startsWith('CalendarDay__hovered_span');
        if (isUpForRemoval) {
          classNamesForRemoval.push(className);
        }
      });
    }
    classNamesForRemoval.forEach(function (className) {
      return $day.parentNode.classList.remove(className);
    });
  });
}
function DayPickerRangeControllerWrapper(props) {
  var initialStartDate = props.initialStartDate,
    initialEndDate = props.initialEndDate,
    showInputs = props.showInputs,
    maxLOS = props.maxLOS,
    datesChangeHandler = props.datesChangeHandler,
    checkInLabel = props.checkInLabel,
    checkOutLabel = props.checkOutLabel,
    handleChange = props.handleChange,
    dateRanges = props.dateRanges,
    externalFocus = props.externalFocus,
    locale = props.locale,
    fullScreenPortalTitle = props.fullScreenPortalTitle,
    showBlockedDaysReferences = props.showBlockedDaysReferences,
    departureOnlyLabel = props.departureOnlyLabel,
    noAvailabilityLabel = props.noAvailabilityLabel,
    minLOS = props.minLOS,
    minNightOffset = props.minNightOffset,
    isQA = props.isQA,
    minLOSTooltipLabel = props.minLOSTooltipLabel,
    maxLOSTooltipLabel = props.maxLOSTooltipLabel,
    noDepartureTooltipLabel = props.noDepartureTooltipLabel,
    getNightsCountLabel = props.getNightsCountLabel,
    doneButtonLabel = props.doneButtonLabel,
    resetButtonLabel = props.resetButtonLabel,
    cancelButtonLabel = props.cancelButtonLabel,
    showPrice = props.showPrice,
    isAlwaysOpen = props.isAlwaysOpen,
    dayPrices = props.dayPrices,
    taxInfoLabel = props.taxInfoLabel,
    priceDisplayMode = props.priceDisplayMode,
    getCheckOutSummaryLabel = props.getCheckOutSummaryLabel,
    dateSelectMode = props.dateSelectMode,
    preventDateSelectionOnOutsideClick = props.preventDateSelectionOnOutsideClick,
    hidePrevButton = props.hidePrevButton,
    priceQualifier = props.priceQualifier,
    triggerChangeOnceEndDateSelected = props.triggerChangeOnceEndDateSelected,
    hidePriceCalendarOnSelect = props.hidePriceCalendarOnSelect,
    onCalendarOpenClose = props.onCalendarOpenClose,
    isCalendarOpen = props.isCalendarOpen,
    showCancelButton = props.showCancelButton,
    showResetButton = props.showResetButton,
    currencyDisplay = props.currencyDisplay,
    currencySymbol = props.currencySymbol,
    getContainerDimension = props.getContainerDimension,
    widthMode = props.widthMode,
    onDatePickingStateChange = props.onDatePickingStateChange,
    showInline = props.showInline,
    fullWidth = props.fullWidth,
    maxPossibleStayDays = props.maxPossibleStayDays;
  var windowSize = useWindowSize();

  // number of days, which server returns as possible stay days for a checkin date
  var MAX_POSSIBLE_STAY_DAYS = maxPossibleStayDays;
  var _useState = useState(windowSize.width <= 768 && !showPrice),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var _useState3 = useState(showPrice && windowSize.width <= 768),
    _useState4 = _slicedToArray(_useState3, 2),
    showOneMonthPrice = _useState4[0],
    setShowOneMonthPrice = _useState4[1];
  var _useState5 = useState(minLOS),
    _useState6 = _slicedToArray(_useState5, 2),
    currentMinLoS = _useState6[0],
    setCurrentMinLoS = _useState6[1];
  var _useState7 = useState(maxLOS),
    _useState8 = _slicedToArray(_useState7, 2),
    currentMaxLoS = _useState8[0],
    setCurrentMaxLoS = _useState8[1];
  var _useState9 = useState(externalFocus !== null && externalFocus !== void 0 ? externalFocus : START_DATE),
    _useState10 = _slicedToArray(_useState9, 2),
    focusedInput = _useState10[0],
    setFocusedInput = _useState10[1];
  var _useState11 = useState(initialStartDate),
    _useState12 = _slicedToArray(_useState11, 2),
    startDate = _useState12[0],
    setStartDate = _useState12[1];
  var _useState13 = useState(initialEndDate),
    _useState14 = _slicedToArray(_useState13, 2),
    endDate = _useState14[0],
    setEndDate = _useState14[1];
  var _useState15 = useState(isCalendarOpen),
    _useState16 = _slicedToArray(_useState15, 2),
    isOpen = _useState16[0],
    _setIsOpen = _useState16[1];
  var _useState17 = useState(DAY_PICKING_STATES.SELECTING_CHECKIN),
    _useState18 = _slicedToArray(_useState17, 2),
    datePickingState = _useState18[0],
    setDatePickingState_ = _useState18[1];
  var _useState19 = useState(daysBetween(initialEndDate, initialStartDate)),
    _useState20 = _slicedToArray(_useState19, 2),
    nightsCounter = _useState20[0],
    setNightsCounter = _useState20[1];
  var _useState21 = useState(dayPrices),
    _useState22 = _slicedToArray(_useState21, 2),
    prices = _useState22[0],
    setPrices = _useState22[1];
  var _useState23 = useState(mapPricesToDayPricesMap(dayPrices)),
    _useState24 = _slicedToArray(_useState23, 2),
    pricesByDate = _useState24[0],
    setPricesByDate = _useState24[1];
  var _useState25 = useState(getMainWrapperClassNames({
      showPrice: showPrice,
      showInline: showInline,
      fullWidth: fullWidth
    })),
    _useState26 = _slicedToArray(_useState25, 2),
    mainWrapperCls = _useState26[0],
    setMainWrapperCls = _useState26[1];
  var _useState27 = useState(startDate && moment(startDate).format(dateFormat)),
    _useState28 = _slicedToArray(_useState27, 2),
    startDateLabel = _useState28[0],
    setStartDateLabel = _useState28[1];
  var _useState29 = useState(endDate && moment(endDate).format(dateFormat)),
    _useState30 = _slicedToArray(_useState29, 2),
    endDateLabel = _useState30[0],
    setEndDateLabel = _useState30[1];

  // https://github.com/react-dates/react-dates/issues/1985
  // we need this aweful re-rendering for applying locale changes. If this is not done,
  // the weekday names are not correctly updated.
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    isAwefulReactDatesWorkaroundRequired = _useState32[0],
    setAwefulReactDatesWorkaroundRequired = _useState32[1];
  var getCalendarDimensions = useCallback(function (calendarWrapper) {
    if (widthMode === 'AUTO' || isMobile) {
      var calendarWidth = calendarWrapper.offsetWidth;
      var windowWidth = windowSize.width;
      var parentNode = calendarWrapper.parentNode;
      var leftOffset = 0;
      if (parentNode && !isMobile) {
        var parentLeftOffset = parentNode.getBoundingClientRect().left;
        var centeredLeftOffset = Math.floor((windowWidth - calendarWidth) / 2) - parentLeftOffset;
        leftOffset = Math.max(-1 * Math.abs(parentLeftOffset), centeredLeftOffset);
      }
      return {
        width: calendarWrapper.offsetWidth,
        leftOffset: leftOffset
      };
    }
    return getContainerDimension();
  }, [getContainerDimension, widthMode, windowSize === null || windowSize === void 0 ? void 0 : windowSize.width, isMobile]);
  var updateLoS = useCallback(function (startDate) {
    if (!showPrice) {
      return;
    }
    if (!startDate) {
      setCurrentMinLoS(minLOS);
      setCurrentMaxLoS(maxLOS);
      return;
    }
    var dateKey = typeof startDate === 'string' ? startDate : startDate.format('YYYY-MM-DD');
    var priceObj = pricesByDate[dateKey];
    if (priceObj && priceObj.minLengthOfStay) {
      var priceMinLoS = priceObj.minLengthOfStay;

      // due to the limitation of the calendar endpoint, we do not update the
      // max los from the selected start date -> will be wrong
      setCurrentMinLoS(priceMinLoS !== null && priceMinLoS !== void 0 ? priceMinLoS : minLOS);
    }
  }, [showPrice, pricesByDate, minLOS, maxLOS]);
  var setIsOpen = useCallback(function (isOpen) {
    _setIsOpen(isOpen);
    if (typeof onCalendarOpenClose === 'function') {
      onCalendarOpenClose(isOpen);
    }
  }, [onCalendarOpenClose]);
  useEffect(function () {
    setMainWrapperCls(getMainWrapperClassNames({
      showPrice: showPrice,
      showInline: showInline,
      fullWidth: fullWidth
    }));
  }, [showPrice, showInline, fullWidth]);
  useEffect(function () {
    if (!(calendarRef === null || calendarRef === void 0 ? void 0 : calendarRef.current)) {
      return;
    }
    var isCurrentlyMobileWidth = windowSize.width <= 768;
    var calendarNode = calendarRef.current.getElementsByClassName('DayPicker');
    var calendarWrapper = calendarNode[0];
    if (calendarWrapper === null || calendarWrapper === void 0 ? void 0 : calendarWrapper.style) {
      calendarWrapper.style['max-width'] = "".concat(windowSize.width, "px");
    }
    setIsMobile(isCurrentlyMobileWidth && !showPrice);
    setShowOneMonthPrice(showPrice && isCurrentlyMobileWidth);
  }, [windowSize.width, showPrice]);

  // this is a workaround because the useCallback wrapped isPriceOutsideAvailableRange function
  // does not update the function even when the datePickingState changes
  var datePickingStateRef = useRef(datePickingState);
  var setDatePickingState = function setDatePickingState(state) {
    datePickingStateRef.current = state;
    setDatePickingState_(state);
    if (typeof onDatePickingStateChange === 'function') {
      onDatePickingStateChange(state);
    }
  };
  var dateFormat = moment().localeData().longDateFormat('L');
  var isDateRangeSelected = function isDateRangeSelected() {
    return !!startDate && !!endDate;
  };
  var firstBookableDay = useMemo(function () {
    return addDays(moment().startOf('day'), minNightOffset);
  }, [minNightOffset]);
  var firstDayExceedMinLos = useMemo(function () {
    return addDays(firstBookableDay, currentMinLoS);
  }, [firstBookableDay, currentMinLoS]);
  var isPriceOutsideAvailableRange = useCallback(function (startDay, day, prices) {
    if (!prices || !startDay || !day || !prices.length) {
      return false;
    }
    var firstPrice = prices[0];
    var firstDate = moment(firstPrice.day, 'YYYY-MM-DD');
    if (day.isBefore(firstDate)) {
      return true;
    }
    if (datePickingStateRef.current === DAY_PICKING_STATES.SELECTING_CHECKIN) {
      return false;
    }

    // if the start day is after the first date, we need to start at 0
    var offsetIdx = Math.max(startDay.diff(firstDate, 'days'), 0);
    var lastIdx = day.diff(firstDate, 'days');
    for (var i = offsetIdx; i < Math.min(lastIdx, prices.length); i++) {
      var priceObj = prices[i];
      if (!hasDayObjValidPrice(priceObj)) {
        return true;
      }
    }
    return false;
  }, [startDate, prices, datePickingState]);
  var initialSelectionSetup = function initialSelectionSetup() {
    return setDatePickingState(DAY_PICKING_STATES.SELECTING_CHECKIN);
  };
  var priceSetup = function priceSetup(showPrice) {
    if (showPrice) {
      setDatePickingState(DAY_PICKING_STATES.SELECTING_CHECKOUT);
    }
  };
  var pickedDayPricesChange = function pickedDayPricesChange() {
    setPricesByDate(mapPricesToDayPricesMap(dayPrices));
    setPrices(dayPrices);
  };
  useEffect(function () {
    setPrices(dayPrices);
    var pricesByDay = mapPricesToDayPricesMap(dayPrices);
    setPricesByDate(pricesByDay);
  }, [dayPrices]);
  var priceLoadingState = JSON.stringify(dayPrices.map(function (p) {
    return p.loading;
  }));
  useEffect(function () {
    if (!isDoneButtonActive(dayPrices, startDate, endDate)) {
      setStartDate(null);
      setEndDate(null);
    }
  }, [priceLoadingState, startDate, endDate]);
  useEffect(function () {
    var getAsLocalizedDate = function getAsLocalizedDate(d) {
      var parsedDate = _typeof(d) === 'object' ? d.clone() : moment(d, 'YYYY-MM-DD');
      return parsedDate.locale(locale);
    };
    moment.locale(locale);
    if (startDate) {
      setStartDate(getAsLocalizedDate(startDate));
      setStartDateLabel(startDate && startDate.format(dateFormat));
    }
    if (endDate) {
      setEndDate(getAsLocalizedDate(endDate));
      setEndDateLabel(endDate && endDate.format(dateFormat));
    }
    setAwefulReactDatesWorkaroundRequired(true);
    setTimeout(function () {
      setAwefulReactDatesWorkaroundRequired(false);
    }, 0);
    // Only updates on locale changes are required here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);
  useEffect(function () {
    setStartDate(initialStartDate);
    setEndDate(initialEndDate);
    setStartDateLabel(initialStartDate && moment(initialStartDate).format(dateFormat));
    setEndDateLabel(initialEndDate && moment(initialEndDate).format(dateFormat));
    if (initialStartDate && initialEndDate) {
      initialSelectionSetup();
      setNightsCounter(daysBetween(initialEndDate, initialStartDate));
    }
  }, [initialStartDate === null || initialStartDate === void 0 ? void 0 : initialStartDate.format('YYYY-MM-DD'), initialEndDate === null || initialEndDate === void 0 ? void 0 : initialEndDate.format('YYYY-MM-DD')]);
  useEffect(function () {
    var _prices, _dayPrices;
    var bothSelected = datePickingState === DAY_PICKING_STATES.SELECTING_CHECKIN && endDate;
    var hasCheckinSelected = datePickingState === DAY_PICKING_STATES.SELECTING_CHECKOUT && !endDate;
    if (hasCheckinSelected || bothSelected) {
      return;
    }
    (_prices = prices[prices.length - 1]) === null || _prices === void 0 ? void 0 : _prices.day;
    (_dayPrices = dayPrices[dayPrices.length - 1]) === null || _dayPrices === void 0 ? void 0 : _dayPrices.day;
    pickedDayPricesChange();
  }, [dayPrices, datePickingState, endDate]);
  useEffect(function () {
    cleanUpWronglyHighlightedDays(calendarRef, startDate, endDate);
  }, [startDate, endDate]);
  var updateCalendarPosition = useCallback(function () {
    if (!(calendarRef === null || calendarRef === void 0 ? void 0 : calendarRef.current)) {
      return;
    }
    var calendarNode = calendarRef.current.getElementsByClassName('DayPicker');
    if (calendarNode.length) {
      var calendarWrapper = calendarNode[0];
      var calendarBoundings = calendarWrapper.getBoundingClientRect();
      if (calendarBoundings !== undefined && calendarWrapper !== undefined) {
        if (calendarWrapper === null || calendarWrapper === void 0 ? void 0 : calendarWrapper.style) {
          if (widthMode === 'AUTO') {
            calendarWrapper.style['max-width'] = "".concat(windowSize.width, "px");
            calendarWrapper.style['min-width'] = 'auto';
          }
          var parentNode = calendarWrapper.parentNode;
          if (parentNode) {
            var _getCalendarDimension = getCalendarDimensions(calendarWrapper),
              leftOffset = _getCalendarDimension.leftOffset,
              width = _getCalendarDimension.width,
              topOffset = _getCalendarDimension.topOffset;
            calendarWrapper.style.left = "".concat(leftOffset, "px");
            if (topOffset !== undefined) {
              calendarWrapper.style.top = "".concat(topOffset, "px");
            }
            if (widthMode === 'CUSTOM_WIDTH') {
              calendarWrapper.style.width = "".concat(width, "px");
              calendarWrapper.style['min-width'] = "".concat(width, "px");
              calendarWrapper.style['max-width'] = "".concat(width, "px");
              setTimeout(function () {
                if (width !== getCalendarDimensions(calendarWrapper).width) {
                  updateCalendarPosition();
                }
              }, 50);
            }
          } else {
            calendarWrapper.style.left = '0px';
          }
        }
      }
    }
  });
  useEffect(function () {
    if (!isOpen && !isAlwaysOpen) {
      return;
    }
    updateCalendarPosition();
  });
  useEffect(function () {
    if (!(calendarRef === null || calendarRef === void 0 ? void 0 : calendarRef.current)) {
      return;
    }
    var calendarNode = calendarRef.current.getElementsByClassName('DayPicker');
    var headerNode = calendarRef.current.getElementsByClassName('bf-modal-header');
    var footerNode = calendarRef.current.getElementsByClassName('bf-date-range-picker-footer');
    var scrollableContainerNode = calendarRef.current.getElementsByClassName('DayPicker_transitionContainer__verticalScrollable');
    var calendarDayNames = calendarRef.current.getElementsByClassName('DayPicker_weekHeaders');
    var calendarHeight;
    var headerHeight;
    var footerHeight;
    if (calendarNode.length) {
      var calendarWrapper = calendarNode[0];
      var calendarBoundings = calendarWrapper.getBoundingClientRect();
      calendarHeight = calendarBoundings === null || calendarBoundings === void 0 ? void 0 : calendarBoundings.height;
    }
    if (headerNode.length) {
      var headerWrapper = headerNode[0];
      var headerBoundings = headerWrapper.getBoundingClientRect();
      headerHeight = headerBoundings === null || headerBoundings === void 0 ? void 0 : headerBoundings.height;
    }
    if (footerNode.length) {
      var footerWrapper = footerNode[0];
      var footerBoundings = footerWrapper.getBoundingClientRect();
      footerHeight = footerBoundings === null || footerBoundings === void 0 ? void 0 : footerBoundings.height;
    }
    if (scrollableContainerNode.length) {
      var calendarViewportWrapper = scrollableContainerNode[0];
      var calendarDayNamesWrapper = calendarDayNames[0];
      // full height minus header, footer and top padding
      var calendarViewportHeight = calendarHeight - headerHeight - footerHeight - 20;
      if (calendarViewportWrapper !== undefined && calendarDayNamesWrapper !== undefined) {
        calendarViewportWrapper.style.height = "".concat(calendarViewportHeight, "px");
        calendarViewportWrapper.style.top = "".concat(headerHeight, "px");
        calendarDayNamesWrapper.style.top = "".concat(headerHeight, "px");
      }
    }
  });
  useEffect(function () {
    if (!isMobile && isOpen && !isAlwaysOpen) {
      setIsOpen(false);
    }
  }, [isMobile]);
  var tooltipContent = useCallback(function (day) {
    if (datePickingState !== DAY_PICKING_STATES.SELECTING_CHECKOUT) {
      return '';
    }
    if (isBetweenDates(day, startDate, addDays(startDate, currentMinLoS), '[)')) {
      var minLosLabel = typeof minLOSTooltipLabel === 'function' ? minLOSTooltipLabel(currentMinLoS) : minLOSTooltipLabel;
      return minLosLabel;
    }
    if (isAfter(day, addDays(startDate, currentMaxLoS))) {
      var maxLosLabel = maxLOSTooltipLabel === 'function' ? maxLOSTooltipLabel(currentMaxLoS) : maxLOSTooltipLabel;
      return maxLosLabel;
    }
    var dayPrice = dayPrices.find(function (item) {
      return item.day.isSame(day, 'day');
    });
    if ((dayPrice === null || dayPrice === void 0 ? void 0 : dayPrice.scope) && !dayPrice.scope.includes('DEPARTURE') && noDepartureTooltipLabel) {
      return typeof noDepartureTooltipLabel === 'function' ? noDepartureTooltipLabel() : noDepartureTooltipLabel;
    }
    return '';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, currentMinLoS, currentMaxLoS, minLOSTooltipLabel, maxLOSTooltipLabel, noDepartureTooltipLabel, datePickingState]);
  var calculateNightsOnHover = useCallback(function (day) {
    if (datePickingState !== DAY_PICKING_STATES.SELECTING_CHECKIN && currentMinLoS !== currentMaxLoS) {
      setNightsCounter(daysBetween(day, startDate));
    }
  }, [startDate, datePickingState, currentMinLoS, currentMaxLoS]);
  var getCheckoutPrices = function getCheckoutPrices(start) {
    var _dayPrices$find;
    return ((_dayPrices$find = dayPrices.find(function (item) {
      return item.day.isSame(start, 'day');
    })) === null || _dayPrices$find === void 0 ? void 0 : _dayPrices$find.checkoutPrices) || [];
  };
  var handleCancelButton = useCallback(function () {
    setStartDate(null);
    if (endDate) {
      setEndDate(null);
    }
    setPrices(dayPrices);
    setPricesByDate(mapPricesToDayPricesMap(dayPrices));
    setDatePickingState(DAY_PICKING_STATES.SELECTING_CHECKIN);
    setFocusedInput(START_DATE);
    handleChange({
      startDate: null,
      endDate: null,
      fromAction: 'CANCEL'
    });
  }, [endDate, dayPrices]);
  var onDatesChange = function onDatesChange(_ref2) {
    var newStartDate = _ref2.startDate,
      newEndDate = _ref2.endDate;
    // notify the parent component about the change in calendar dates
    datesChangeHandler({
      startDate: newStartDate,
      endDate: newEndDate
    });
    if (triggerChangeOnceEndDateSelected && newStartDate && newEndDate) {
      handleChange({
        startDate: newStartDate,
        endDate: newEndDate,
        fromAction: 'SELECT'
      });
    }
    if (dateSelectMode === 'NO_RESET' && isDateRangeSelected()) {
      return;
    }
    if (dateSelectMode === 'RESET_ON_RESELECT' && isDateRangeSelected()) {
      handleCancelButton();
      return;
    }

    // case for select a checkout previous to the actual checkin
    if (datePickingState === DAY_PICKING_STATES.SELECTING_CHECKOUT) {
      if (isBefore(newStartDate, startDate)) {
        updateStartDate(newStartDate, showPrice);
      } else {
        updateEndDate(newEndDate);
      }
    } else if (currentMinLoS === currentMaxLoS && currentMinLoS > 0 && currentMaxLoS > 0) {
      // If both LOS restrictions are the same preselect the checkout
      var maximumEndDate = addDays(newStartDate, currentMaxLoS);
      updateStartAndEndDate(newStartDate, maximumEndDate);
    } else if (datePickingState === DAY_PICKING_STATES.SELECTING_CHECKIN) {
      updateStartDate(newStartDate, showPrice);
    }
  };
  var updateStartDate = function updateStartDate(newStartDate, showPrice) {
    updateLoS(newStartDate);
    setStartDate(newStartDate);
    setStartDateLabel(newStartDate && newStartDate.format(dateFormat));
    setEndDate(null);
    setNightsCounter(1);
    highlightInputField(END_DATE);
    priceSetup(showPrice);
  };
  var updateEndDate = function updateEndDate(newEndDate) {
    setEndDate(newEndDate);
    setEndDateLabel(newEndDate && newEndDate.format(dateFormat));
    highlightInputField(START_DATE);
  };
  var updateStartAndEndDate = function updateStartAndEndDate(newStartDate, newEndDate) {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    setStartDateLabel(newStartDate && newStartDate.format(dateFormat));
    setEndDateLabel(newEndDate && newEndDate.format(dateFormat));
    highlightInputField(START_DATE);
  };
  var highlightInputField = function highlightInputField(inputField) {
    if (inputField === START_DATE) {
      setFocusedInput(START_DATE);
      setDatePickingState(DAY_PICKING_STATES.SELECTING_CHECKIN);
    } else if (inputField === END_DATE) {
      setFocusedInput(END_DATE);
      setDatePickingState(DAY_PICKING_STATES.SELECTING_CHECKOUT);
    }
  };
  var handleCheckinClick = useCallback(function () {
    if (!isOpen) {
      setIsOpen(true);
    }
    setDatePickingState(DAY_PICKING_STATES.SELECTING_CHECKIN);
    setFocusedInput(START_DATE);
  }, [isOpen, setIsOpen, setDatePickingState, setFocusedInput]);
  var handleCheckoutClick = useCallback(function () {
    var isSameLos = currentMinLoS === currentMaxLoS;
    if (!isOpen) {
      setIsOpen(true);
    }
    setDatePickingState(isSameLos ? DAY_PICKING_STATES.SELECTING_CHECKIN : DAY_PICKING_STATES.SELECTING_CHECKOUT);
    setFocusedInput(!isSameLos ? END_DATE : START_DATE);
  }, [isOpen, currentMinLoS, currentMaxLoS, setIsOpen, setDatePickingState, setFocusedInput]);
  var handleDoneButton = useCallback(function (shouldClose) {
    var hasBookableDays = dayPrices.some(function (dayPrice) {
      return dayPrice.available;
    });
    var isAvailabilityIndependent = !dayPrices.length;
    var enforceDateSelection = hasBookableDays || isAvailabilityIndependent;
    if (startDate && endDate) {
      handleChange({
        startDate: setEnLocaleDate(startDate),
        endDate: setEnLocaleDate(endDate),
        fromAction: 'DONE'
      });
    } else if (enforceDateSelection) {
      return;
    }
    if (shouldClose && !isAlwaysOpen) {
      setIsOpen(false);
    }
  }, [startDate, endDate, handleChange, isAlwaysOpen, setIsOpen, dayPrices]);
  var handleResetButton = useCallback(function () {
    setStartDate(initialStartDate);
    setEndDate(initialEndDate);
    setStartDateLabel(initialStartDate && moment(initialStartDate).format(dateFormat));
    setEndDateLabel(initialEndDate && moment(initialEndDate).format(dateFormat));
    setNightsCounter(daysBetween(initialEndDate, initialStartDate));
    setPrices(dayPrices);
    setPricesByDate(mapPricesToDayPricesMap(dayPrices));
    setDatePickingState(DAY_PICKING_STATES.SELECTING_CHECKIN);
    setFocusedInput(START_DATE);
    setCurrentMinLoS(minLOS);
    setCurrentMaxLoS(maxLOS);
    cleanUpWronglyHighlightedDays(calendarRef, initialStartDate, initialEndDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, isAlwaysOpen, setIsOpen]);
  var getCheckOutDayPrice = useCallback(function () {
    var _getCheckoutPrices$fi;
    var selectedCheckOutDate = moment(endDate).format('YYYY-MM-DD');
    var selectedDayPrice = (_getCheckoutPrices$fi = getCheckoutPrices(startDate).find(function (item) {
      return item.day.isSame(selectedCheckOutDate, 'day');
    })) === null || _getCheckoutPrices$fi === void 0 ? void 0 : _getCheckoutPrices$fi.price;
    return hasDayPriceFormatted(selectedDayPrice) ? selectedDayPrice : formatNumber(selectedDayPrice, locale);
  }, [endDate, startDate, getCheckoutPrices, locale]);

  /**
   * @param {MouseEvent} event
   */
  var handleOutsideClick = function handleOutsideClick(event) {
    // react-dates detects outside clicks where it shouldnt, I have to escape this case
    var path = null;
    if (!preventDateSelectionOnOutsideClick) {
      var _path, _path2;
      path = (_path = path) !== null && _path !== void 0 ? _path : event.composedPath();
      var exceptedClassNames = ['bf-date-range-picker-inputs-wrapper', 'bf-search-bar-item', 'bf-date-range-picker-input'];
      var isClickOnInput = (_path2 = path) === null || _path2 === void 0 ? void 0 : _path2.some(function (domElem) {
        return exceptedClassNames.some(function (className) {
          var _domElem$classList;
          return (_domElem$classList = domElem.classList) === null || _domElem$classList === void 0 ? void 0 : _domElem$classList.contains(className);
        });
      });
      if (!isClickOnInput) {
        // Treat outside click as apply
        handleDoneButton(true);
      }
    }
  };
  var renderDayContents = useCallback(function (day) {
    var isoDateOfDay = day.format('YYYY-MM-DD');
    if (dateRanges) {
      // values -> returns the values by the order they were inserted
      var isFirstDay = pricesByDate[isoDateOfDay] === Object.values(pricesByDate)[0];
      for (var index = 0; index < dateRanges.length; index++) {
        var _dateRanges$index$ran = dateRanges[index].range,
          start = _dateRanges$index$ran.start,
          end = _dateRanges$index$ran.end;
        var useInclusiveCheck = index === 0 && isFirstDay;
        var dateComparisonInclusivity = useInclusiveCheck ? '[]' : '(]';
        if (isBetweenDates(day, start, end, dateComparisonInclusivity) || shouldFirstDepartureDateBeClosed(day, start, firstDayExceedMinLos)) {
          var _dayPrice = pricesByDate[day.format('YYYY-MM-DD')];
          var isDayBlocked = isPriceDayBlocked(_dayPrice, datePickingState, startDate);
          if (!isDayBlocked && datePickingState !== DAY_PICKING_STATES.SELECTING_CHECKIN) {
            return /*#__PURE__*/React__default.createElement(DepartureDay, {
              day: day,
              isQA: isQA,
              tooltipContent: tooltipContent,
              calculateNightsOnHover: calculateNightsOnHover
            });
          } else {
            return /*#__PURE__*/React__default.createElement(BlockedDay, {
              day: day,
              isQA: isQA,
              isSelectingCheckin: datePickingState === DAY_PICKING_STATES.SELECTING_CHECKIN,
              tooltipContent: tooltipContent,
              calculateNightsOnHover: calculateNightsOnHover
            });
          }
        }
        if (start.isSame(day, 'day')) {
          return /*#__PURE__*/React__default.createElement(DepartureDay, {
            day: day,
            isQA: isQA,
            isSelectingCheckin: datePickingState === DAY_PICKING_STATES.SELECTING_CHECKIN,
            tooltipContent: tooltipContent,
            calculateNightsOnHover: calculateNightsOnHover
          });
        }
      }
    }

    // get the price for the start day, so we can display it on the calendar, when date is selected
    var isStartDate = startDate === null || startDate === void 0 ? void 0 : startDate.isSame(day, 'day');
    var isEndDate = endDate && day.isSame(endDate, 'day');
    var dayPrice = pricesByDate[isoDateOfDay];
    return /*#__PURE__*/React__default.createElement(FastAvailableDay, {
      day: day,
      isSelectingCheckin: datePickingState === DAY_PICKING_STATES.SELECTING_CHECKIN,
      isQA: isQA,
      tooltipContent: tooltipContent,
      calculateNightsOnHover: calculateNightsOnHover,
      showPrice: showPrice,
      currencyDisplay: currencyDisplay,
      currencySymbol: currencySymbol,
      currencyCode: dayPrice === null || dayPrice === void 0 ? void 0 : dayPrice.currencyCode,
      price: dayPrice === null || dayPrice === void 0 ? void 0 : dayPrice.price,
      locale: locale,
      isLoading: dayPrice === null || dayPrice === void 0 ? void 0 : dayPrice.loading,
      priceQualifier: priceQualifier,
      nightsCounter: isEndDate ? nightsCounter : null,
      getNightsCountLabel: getNightsCountLabel,
      isStartDate: isStartDate,
      isDayAllowedForCheckout: true
    });
  }, [dateRanges, pricesByDate, datePickingState, isQA, tooltipContent, calculateNightsOnHover, showPrice, locale, firstDayExceedMinLos, isPriceOutsideAvailableRange, startDate, dayPrices]);
  function renderCheckOutSummary(nightsCounter, startDate, endDate) {
    if (startDate && endDate) {
      return /*#__PURE__*/React__default.createElement("strong", {
        className: "check-out-summary-info"
      }, getCheckOutSummaryLabel(nightsCounter, startDate, endDate));
    }
    return null;
  }
  var checkOutSummary = renderCheckOutSummary(nightsCounter, startDate, endDate);
  var getDoneButtonLabel = useCallback(function () {
    if (typeof doneButtonLabel === 'function') {
      return doneButtonLabel(getCheckOutDayPrice());
    }
    return doneButtonLabel;
  }, [doneButtonLabel, getCheckOutDayPrice]);
  var renderCalendarInfo = useCallback(function () {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isMobile ? /*#__PURE__*/React__default.createElement(ModalHeader, {
      title: fullScreenPortalTitle,
      closeIcon: true,
      onClose: function onClose() {
        return handleDoneButton(true);
      }
    }) : null, /*#__PURE__*/React__default.createElement(CalendarInfoFooter, {
      showPrice: showPrice,
      hidePriceCalendarOnSelect: hidePriceCalendarOnSelect,
      getDoneButtonLabel: getDoneButtonLabel,
      resetButtonLabel: resetButtonLabel,
      cancelButtonLabel: cancelButtonLabel,
      startDate: startDate,
      endDate: endDate,
      noAvailabilityLabel: noAvailabilityLabel,
      priceDisplayMode: priceDisplayMode,
      taxInfoLabel: taxInfoLabel,
      checkOutSummary: checkOutSummary,
      datePickingState: datePickingState,
      showCancelButton: showCancelButton,
      showResetButton: showResetButton,
      handleCancelButton: handleCancelButton,
      handleDoneButton: handleDoneButton,
      handleResetButton: handleResetButton,
      showBlockedDaysReferences: showBlockedDaysReferences,
      departureOnlyLabel: departureOnlyLabel,
      getNightsCountLabel: getNightsCountLabel,
      nightsCounter: nightsCounter
    }));
  }, [isMobile, nightsCounter, startDate, endDate, datePickingState, getDoneButtonLabel, locale]);
  var handleIsDayBlocked = useCallback(function (day) {
    // day exceeds the max LOS
    var isSelectingCheckin = datePickingState === DAY_PICKING_STATES.SELECTING_CHECKIN;
    if (datePickingState === DAY_PICKING_STATES.SELECTING_CHECKOUT && day.isAfter(startDate)) {
      var _startDayPrice$possib;
      var startDayPrice = dayPrices.find(function (item) {
        return item.day.clone().startOf('day').isSame(startDate.clone().startOf('day'));
      });

      // in case that possible stay days array is defined for checkin date, check if the index of the day exists
      // in this array. If not, the day is blocked, with one exception: if the index of the day is greater then
      // maximum number of days, which server can return as possible stay days for a checkin date, then the day
      // is not blocked. This is because of the limitation of the calendar endpoint, which returns only a limited
      // number of possible stay days for a checkin date.
      if ((startDayPrice === null || startDayPrice === void 0 ? void 0 : (_startDayPrice$possib = startDayPrice.possibleStays) === null || _startDayPrice$possib === void 0 ? void 0 : _startDayPrice$possib.length) > 0) {
        var _daysBetween = day.clone().startOf('day').diff(startDate.clone().startOf('day'), 'days');
        if (_daysBetween <= MAX_POSSIBLE_STAY_DAYS && !startDayPrice.possibleStays.includes(_daysBetween)) {
          return true;
        }
      }
    }
    if (maxLOS && !isSelectingCheckin && isAfter(day, addDays(startDate, maxLOS))) {
      return true;
    }
    if (showPrice) {
      var dayPrice = pricesByDate[day.format('YYYY-MM-DD')];
      return isPriceDayBlocked(dayPrice, datePickingState, startDate);
    }

    // blocked days and departure only days
    for (var index = 0; index < dateRanges.length; index++) {
      var _dateRanges$index$ran2 = dateRanges[index].range,
        start = _dateRanges$index$ran2.start,
        end = _dateRanges$index$ran2.end;
      // special case for departure only days blocked for first bookable day
      if (shouldFirstDepartureDateBeClosed(day, start, firstDayExceedMinLos)) {
        return true;
      }
      // day closed and departure only selecting checkin
      if (isSelectingCheckin && isBetweenDates(day, start, end, '[]')) {
        return true;
      }
      // day passing closed range
      if (!isSelectingCheckin && isBefore(startDate, start) && isAfter(day, start)) {
        return true;
      }
      // days closed selecting checkin previous to actual checkin
      if (!isSelectingCheckin && isBetweenDates(day, start, end, '[]') && isBefore(day, startDate)) {
        return true;
      }
      // validate same LOS
      if (currentMinLoS === currentMaxLoS && currentMinLoS > 0 && currentMaxLoS > 0) {
        var maximumEndDate = addDays(day, currentMaxLoS);
        if (isBetweenDates(maximumEndDate, start, end, '()')) {
          return true;
        }
      }
      // avoid days for which the minimum cannot be met due to blocked days in between
      if (isSelectingCheckin && isBefore(day, start) && isAfter(addDays(day, currentMinLoS), start)) {
        return true;
      }
      if (!isSelectingCheckin && isBefore(day, startDate) && isBefore(day, start) && isAfter(addDays(day, currentMinLoS), start)) {
        return true;
      }
    }
    return false;
  }, [datePickingState, maxLOS, startDate, showPrice, pricesByDate, dateRanges, firstDayExceedMinLos, currentMinLoS, currentMaxLoS]);
  var handleOutsideRange = useCallback(function (day) {
    var isBeforeFirstBookableDate = isInclusivelyAfterDay(day, firstBookableDay);
    if (!isBeforeFirstBookableDate) {
      return true;
    }
    if (showPrice) {
      return isPriceOutsideAvailableRange(startDate, day, prices);
    }
    return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstBookableDay, showPrice, startDate, prices]);
  var newProps = omitNew(props, ['autoFocus', 'autoFocusEndDate', 'initialStartDate', 'initialEndDate', 'showInputs', 'handleChange', 'minLOS', 'maxLOS', 'minNightOffset', 'dateRanges', 'checkInLabel', 'checkOutLabel', 'fullScreenPortalTitle', 'locale', 'arrivalsOnlyLabel', 'departureOnlyLabel', 'noAvailabilityLabel', 'minLOSTooltipLabel', 'maxLOSTooltipLabel', 'noDepartureTooltipLabel', 'getNightsCountLabel', 'doneButtonLabel', 'resetButtonLabel', 'isQA', 'externalFocus', 'showBlockedDaysReferences', 'withFullScreenPortal', 'cancelButtonLabel', 'showPrice', 'isAlwaysOpen', 'dayPrices', 'priceDisplayMode', 'taxInfoLabel', 'getCheckOutSummaryLabel', 'preventDateSelectionOnOutsideClick', 'dateSelectMode', 'hidePrevButton', 'triggerChangeOnceEndDateSelected', 'priceQualifier', 'hidePriceCalendarOnSelect', 'onCalendarOpenClose', 'isCalendarOpen', 'showCancelButton', 'showResetButton', 'widthMode', 'onDatePickingStateChange', 'currencyDisplay', 'currencySymbol', 'currencyCode', 'getContainerDimension', 'datesChangeHandler', 'getMinLosLabel', 'fullWidth', 'showInline', 'maxPossibleStayDays']);
  var _ref3 = isQA ? [startDateLabel, endDateLabel] : [null, null],
    _ref4 = _slicedToArray(_ref3, 2),
    dataTestCalendarDateFrom = _ref4[0],
    dataTestCalendarDateTo = _ref4[1];
  var calendarRef = useRef();
  var numberOfMonths = isMobile ? 6 : 2;
  if (showOneMonthPrice) {
    numberOfMonths = 1;
  }
  useEffect(function () {
    // Sometimes the datepicker needs to be rerendered due to bugs in react-dates
    // https://github.com/react-dates/react-dates/issues/1985
    // https://github.com/react-dates/react-dates/issues/2106
    if (!isAlwaysOpen) {
      setIsOpen(false);
    }
  }, [numberOfMonths, locale, setIsOpen, isAlwaysOpen]);
  if (isAwefulReactDatesWorkaroundRequired) {
    return null;
  }
  var checkInActive = datePickingState === DAY_PICKING_STATES.SELECTING_CHECKIN && isOpen;
  var checkOutActive = datePickingState === DAY_PICKING_STATES.SELECTING_CHECKOUT && isOpen;
  return /*#__PURE__*/React__default.createElement("div", {
    className: mainWrapperCls,
    ref: calendarRef
  }, showInputs ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-date-range-picker-inputs-wrapper"
  }, /*#__PURE__*/React__default.createElement(SearchBarItem, {
    label: checkInLabel,
    content: /*#__PURE__*/React__default.createElement("input", {
      type: "text",
      name: "startDate",
      value: startDateLabel || '',
      readOnly: true,
      className: "bf-date-range-picker-input search-bar-input-custom-class",
      "data-test-calendar-date-from": dataTestCalendarDateFrom
    }),
    className: "bf-date-range-picker-input-wrapper ".concat(checkInActive ? 'is-active' : ''),
    onClick: handleCheckinClick
  }), /*#__PURE__*/React__default.createElement(SearchBarItem, {
    label: checkOutLabel,
    content: /*#__PURE__*/React__default.createElement("input", {
      type: "text",
      name: "endDate",
      value: endDateLabel || '',
      readOnly: true,
      className: "bf-date-range-picker-input search-bar-input-custom-class",
      "data-test-calendar-date-to": dataTestCalendarDateTo
    }),
    className: "bf-date-range-picker-input-wrapper ".concat(checkOutActive ? 'is-active' : ''),
    onClick: handleCheckoutClick
  })) : null, isOpen || isAlwaysOpen && showPrice ? /*#__PURE__*/React__default.createElement(DayPickerRangeController, _extends({
    onDatesChange: onDatesChange,
    focusedInput: focusedInput,
    startDate: startDate,
    endDate: endDate,
    renderCalendarInfo: renderCalendarInfo,
    renderDayContents: renderDayContents,
    isDayBlocked: handleIsDayBlocked,
    orientation: isMobile ? VERTICAL_SCROLLABLE : HORIZONTAL_ORIENTATION,
    withPortal: isMobile,
    numberOfMonths: numberOfMonths,
    minimumNights: currentMinLoS,
    isOutsideRange: handleOutsideRange,
    onOutsideClick: handleOutsideClick,
    daySize: 58,
    transitionDuration: 100,
    noBorder: true,
    noNavPrevButton: hidePrevButton
  }, newProps)) : null);
}
DayPickerRangeControllerWrapper.defaultProps = {
  // example props for the demo
  autoFocusEndDate: false,
  initialStartDate: null,
  initialEndDate: null,
  showInputs: false,
  minDate: null,
  maxDate: null,
  // day presentation and interaction related props
  renderCalendarDay: undefined,
  minLOS: 1,
  maxLOS: 0,
  enableOutsideDays: false,
  daysViolatingMinNightsCanBeClicked: false,
  minNightOffset: 0,
  // calendar presentation and interaction related props
  initialVisibleMonth: null,
  keepOpenOnDateSelect: false,
  isRTL: false,
  renderMonthText: null,
  renderMonthElement: null,
  renderKeyboardShortcutsButton: undefined,
  renderKeyboardShortcutsPanel: undefined,
  hideKeyboardShortcutsPanel: true,
  handleChange: function handleChange() {},
  datesChangeHandler: function datesChangeHandler() {},
  dateRanges: [],
  externalFocus: START_DATE,
  locale: 'en',
  // navigation related props
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  // internationalization
  monthFormat: 'MMMM YYYY',
  // labels
  checkInLabel: CHECK_IN_LABEL,
  checkOutLabel: CHECK_OUT_LABEL,
  fullScreenPortalTitle: FULLSCREEN_PORTAL_TITLE,
  showBlockedDaysReferences: true,
  noAvailabilityLabel: NO_AVAILABILITY_LABEL,
  departureOnlyLabel: DEPARTURE_ONLY_LABEL,
  arrivalsOnlyLabel: ARRIVALS_ONLY_LABEL,
  doneButtonLabel: DONE_BUTTON_LABEL,
  cancelButtonLabel: CANCEL_BUTTON_LABEL,
  resetButtonLabel: RESET_BUTTON_LABEL,
  isQA: false,
  showPrice: false,
  isAlwaysOpen: false,
  dayPrices: [],
  priceDisplayMode: '',
  taxInfoLabel: TAX_INFO_LABEL,
  getCheckOutSummaryLabel: function getCheckOutSummaryLabel() {},
  preventDateSelectionOnOutsideClick: false,
  dateSelectMode: 'ALTERNATING_CHECKIN_CHECKOUT_SELECT',
  hidePrevButton: false,
  triggerChangeOnceEndDateSelected: false,
  hidePriceCalendarOnSelect: false,
  isCalendarOpen: false,
  onCalendarOpenClose: function onCalendarOpenClose() {},
  showCancelButton: true,
  showResetButton: true,
  currencyDisplay: 'code',
  currencySymbol: '',
  currencyCode: '',
  widthMode: 'AUTO',
  getContainerDimension: function getContainerDimension() {},
  onDatePickingStateChange: function onDatePickingStateChange() {},
  noDepartureTooltipLabel: NO_DEPARTURE_TOOLTIP_LABEL,
  fullWidth: false,
  showInline: false,
  maxPossibleStayDays: 14
};
DayPickerRangeControllerWrapper.propTypes = {
  // example props for the demo
  autoFocusEndDate: PropTypes.bool,
  initialStartDate: src.momentObj,
  initialEndDate: src.momentObj,
  showInputs: PropTypes.bool,
  minDate: src.momentObj,
  maxDate: src.momentObj,
  keepOpenOnDateSelect: PropTypes.bool,
  minLOS: PropTypes.number,
  maxLOS: PropTypes.number,
  daysViolatingMinNightsCanBeClicked: PropTypes.bool,
  minNightOffset: PropTypes.number,
  // DayPicker props
  enableOutsideDays: PropTypes.bool,
  initialVisibleMonth: PropTypes.func,
  renderMonthElement: PropTypes.func,
  renderMonthText: PropTypes.func,
  externalFocus: PropTypes.string,
  locale: PropTypes.string,
  navPrev: PropTypes.node,
  navNext: PropTypes.node,
  renderNavPrevButton: PropTypes.func,
  renderNavNextButton: PropTypes.func,
  onPrevMonthClick: PropTypes.func,
  onNextMonthClick: PropTypes.func,
  renderCalendarDay: PropTypes.func,
  renderKeyboardShortcutsButton: PropTypes.func,
  renderKeyboardShortcutsPanel: PropTypes.func,
  hideKeyboardShortcutsPanel: PropTypes.bool,
  handleChange: PropTypes.func,
  datesChangeHandler: PropTypes.func,
  dateRanges: dateRangeShape,
  // i18n
  monthFormat: PropTypes.string,
  noAvailabilityLabel: nodeOrStringProp,
  departureOnlyLabel: nodeOrStringProp,
  arrivalsOnlyLabel: nodeOrStringProp,
  minLOSTooltipLabel: nodeOrStringOrFuncProp,
  maxLOSTooltipLabel: nodeOrStringOrFuncProp,
  noDepartureTooltipLabel: nodeOrStringOrFuncProp,
  getNightsCountLabel: PropTypes.func.isRequired,
  getMinLosLabel: PropTypes.func,
  doneButtonLabel: nodeOrStringOrFuncProp,
  cancelButtonLabel: nodeOrStringOrFuncProp,
  resetButtonLabel: nodeOrStringOrFuncProp,
  priceQualifier: nodeOrStringProp,
  isRTL: PropTypes.bool,
  checkInLabel: nodeOrStringProp,
  checkOutLabel: nodeOrStringProp,
  fullScreenPortalTitle: nodeOrStringProp,
  showBlockedDaysReferences: PropTypes.bool,
  isQA: PropTypes.bool,
  showPrice: PropTypes.bool,
  hidePriceCalendarOnSelect: PropTypes.bool,
  isAlwaysOpen: PropTypes.bool,
  dayPrices: dayPricesShape,
  priceDisplayMode: nodeOrStringProp,
  taxInfoLabel: nodeOrStringProp,
  getCheckOutSummaryLabel: PropTypes.func,
  preventDateSelectionOnOutsideClick: PropTypes.bool,
  hidePrevButton: PropTypes.bool,
  triggerChangeOnceEndDateSelected: PropTypes.bool,
  isCalendarOpen: PropTypes.bool.isRequired,
  currencyDisplay: PropTypes.oneOf(['symbol', 'code']),
  currencyCode: PropTypes.string,
  currencySymbol: PropTypes.string,
  onDatePickingStateChange: PropTypes.func,
  // Date select mode
  dateSelectMode: PropTypes.oneOf(['RESET_ON_RESELECT', 'ALTERNATING_CHECKIN_CHECKOUT_SELECT', 'NO_RESET']),
  onCalendarOpenClose: PropTypes.func,
  showCancelButton: PropTypes.bool,
  showResetButton: PropTypes.bool,
  // Display Mode
  widthMode: PropTypes.oneOf(['CUSTOM_WIDTH', 'AUTO']),
  getContainerDimension: PropTypes.func,
  showInline: PropTypes.bool,
  fullWidth: PropTypes.bool,
  maxPossibleStayDays: PropTypes.number
};

export { DayPickerRangeControllerWrapper as D, DateRangePickerConstants as a, getRegionalLocale as g };
